// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:06.283Z
// Property: 1869 West (ID: 6767906449166965)
// Collections: 14 amenities, 4 floorplans (live), 24 photos, 76 POIs, 2 reviews, 1 virtual tours, 6 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166965",
  "property_external_id": "30933",
  "property_zillow_url": "https://www.zillow.com/apartments/pittsburgh-pa/1869-west/CmPd5f/",
  "property_apartments_url": "https://www.apartments.com/1869-west-pittsburgh-pa/7vzdc6y/",
  "property_google_business_url": "https://www.google.com/maps?cid=262204332528601931",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "1869-west",
  "property_name": "1869 West",
  "property_website_url": "https://www.live1869west.com/",
  "property_domain": "https://www.live1869west.com/",
  "property_address": "1869 Chessland St",
  "property_full_address": "1869 Chessland St, Pittsburgh, PA 15205",
  "property_address_1": "1869 Chessland St",
  "property_address_2": null,
  "property_address_city": "Pittsburgh",
  "property_address_state": "PA",
  "property_address_zip_full": "15205-4041",
  "property_address_zip": "15205",
  "property_address_country": "US",
  "property_address_county": "Allegheny County",
  "property_neighborhood_address": "Westwood",
  "property_address_latitude": "40.428397",
  "property_address_longitude": "-80.05611069999999",
  "property_email": "1869west@aionmanagement.com",
  "property_phone": "8447838890",
  "property_call_tracking_phone": "844-783-8890",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "<p>Choose from our wide array of spacious floor plans and find your perfect landing place in Pittsburgh at 1869 West. Our pet-friendly community provides a comfortable retreat with friendly neighborhood vibes at an affordable price. Here, you can relax in welcoming community spaces, or head to a pub nearby. </p>",
  "property_long_description": "Nestled between Crafton & Greentree neighborhood of Pittsburgh, PA, discover a charming community in the center of it all. 1869 West Apartments presents a modern living experience that’s a fit to our residents’ budget and lifestyle. Offering 1, 2, and 3 Bedroom Apartments with spacious floorplans, these pet-friendly homes feature large closets, contemporary fully-applianced kitchens, and onsite laundry centers. With downtown Pittsburgh only ten minutes away, experience the excitement and culture of a beautiful downtown atmosphere. 1869 West offers many recreational facilities within minutes - tennis, golf, skiing, skating, horseback riding, and vast picnic grounds are never more than a short drive away. 1869 West – the best location at an affordable price.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd911-e641-7324-8989-e9b61469393b.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with white cabinets, black appliances, and marble countertops.",
    "public_id": "019fd911-e641-7324-8989-e9b61469393b",
    "storage_key": "property/6767906449166965/019fd911-e641-7324-8989-e9b61469393b.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "210",
  "property_year_built": "1950",
  "property_year_renovated": null,
  "property_walk_score": "73",
  "property_transit_score": "33",
  "property_business_hours_list": null,
  "property_current_occupancy": "98.09523809523809",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "AION allows residents to have dogs, cats and service animals. All animals must be housebroken. No breeding of any permitted animal is allowed. Additionally, certain breeds of dogs are not permitted or any mix of these breeds of dogs where the following breeds are 50% or more in your dog and verified by veterinary report, please ask for listing of breeds. All residents with a pet(s) are required to sign the Pet Addendum and provide a photo of the pet which should be kept in the resident",
  "property_pet_policy_description": "Pet Policy At 1869 West in Pittsburgh, your furry friends will feel right at home! With a welcoming environment for dogs, cats, and service animals, our pet-friendly community ensures a joyful living experience. Just remember, certain breeds are restricted, so check our pet policy as you plan your new adventure!",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.live1869west.com/",
  "property_resident_portal_url": "https://1869west.loftliving.com/login",
  "property_apply_now_url": "https://www.live1869west.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026e-3d64-7468-a8bb-03ddc3e62172.webp",
  "property_primary_logo_media": {
    "alt_text": "1869 West Apartment Homes logo.",
    "public_id": "019d026e-3d64-7468-a8bb-03ddc3e62172",
    "storage_key": "property/6767906449166965/019d026e-3d64-7468-a8bb-03ddc3e62172.webp",
    "width": 170,
    "height": 80
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d0270-a511-76fd-a777-27e56b36d556.webp",
  "property_secondary_logo_media": {
    "alt_text": "1869 West Apartment Homes logo.",
    "public_id": "019d0270-a511-76fd-a777-27e56b36d556",
    "storage_key": "property/6767906449166965/019d0270-a511-76fd-a777-27e56b36d556.webp",
    "width": 300,
    "height": 125
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d0270-ac92-7459-ae05-9a443714441d.webp",
  "property_icon_media": {
    "alt_text": "W Logo",
    "public_id": "019d0270-ac92-7459-ae05-9a443714441d",
    "storage_key": "property/6767906449166965/019d0270-ac92-7459-ae05-9a443714441d.webp",
    "width": 490,
    "height": 534
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d0270-ac92-7459-ae05-9a443714441d.webp",
  "property_fav_icon_media": {
    "alt_text": "W Logo",
    "public_id": "019d0270-ac92-7459-ae05-9a443714441d",
    "storage_key": "property/6767906449166965/019d0270-ac92-7459-ae05-9a443714441d.webp",
    "width": 490,
    "height": 534
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d0270-b781-711a-ad10-67792985d1c1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "1869 West Apartment Homes logo",
    "public_id": "019d0270-b781-711a-ad10-67792985d1c1",
    "storage_key": "property/6767906449166965/019d0270-b781-711a-ad10-67792985d1c1.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d0270-bfab-72ad-8cff-1a26e1d8dd3d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "1869 West Apartment Homes logo",
    "public_id": "019d0270-bfab-72ad-8cff-1a26e1d8dd3d",
    "storage_key": "property/6767906449166965/019d0270-bfab-72ad-8cff-1a26e1d8dd3d.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "575 - 725",
  "property_sqft_min": "575",
  "property_sqft_max": "725",
  "property_price_range": "855 - 1446",
  "property_price_min": "855",
  "property_price_max": "1446",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/1869west",
  "property_instagram_url": "https://www.instagram.com/live1869west",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJX-N30l_2NIgRS4vvgnOJowM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=West+End%2C+Pittsburgh%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 1869 West",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to 1869 West in Pittsburgh, PA, where modern living meets comfort. Choose from thoughtfully designed one, two, or three-bedroom apartments with stylish oak and white cabinetry. Enjoy a pet-friendly community packed with amenities—from resident activities and online conveniences to a playground and high-speed internet. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to 1869 West, where modern living meets comfort in the heart of Pittsburgh, PA. Choose from our thoughtfully designed one, two, and three-bedroom apartments, each tailored to suit your lifestyle. Browse our available homes and uncover the perfect floor plan that awaits you at 1869 West!",
  "property_home_gallery_blurb": "At 1869 West in vibrant Pittsburgh, PA, modern living awaits with stylish one, two, and three-bedroom floor plans. Enjoy a pet-friendly environment, resident activities, and convenient online portals for rent payments. With 24-hour maintenance and a multitude of amenities including a playground and high-speed internet, picture yourself living here!",
  "property_home_neighborhood_blurb": "At 1869 West in Pittsburgh, a vibrant community awaits you. Nestled near cultural landmarks like the Andy Warhol Museum, the Children's Museum, and the historic Senator John Heinz History Center, your new home positions you close to excitement and exploration. Indulge in local favorites and unforgettable experiences just moments away!",
  "property_home_reviews_blurb": "Welcome to 1869 West in Pittsburgh, where our residents thrive! \"Living here is awesome,\" raves one tenant, praising the convenient storage and exceptional management. With a friendly atmosphere, pet-friendly policies, and dedicated maintenance, we offer the perfect start for anyone looking to create their ideal living space. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At 1869 West in vibrant Pittsburgh, you'll find more than just modern living spaces; immerse yourself in a rich tapestry of culture and convenience. Nearby, explore the Pittsburgh Botanic Garden, the Andy Warhol Museum, and picturesque parks. Discover the perfect blend of relaxation and inspiration right at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At 1869 West in Pittsburgh, PA, our thoughtfully designed one to three-bedroom apartments offer a vibrant lifestyle with modern amenities. Enjoy resident activities, high-speed internet, pet-friendly spaces, and 24-hour maintenance. Come see how our renovated homes, complete with sleek black appliances and stylish oak cabinetry, truly elevate your living experience!",
  "property_applynow_blurb": "At 1869 West in Pittsburgh, PA, choose from thoughtfully designed one, two, or three-bedroom apartments that boast modern white cabinets, sleek black appliances, and updated countertops. Enjoy a vibrant community with resident activities, pet-friendly spaces, and 24-hour maintenance. Your new home awaits—lease online today!",
  "property_contactus_blurb": "At 1869 West in Pittsburgh, PA, our thoughtfully designed floor plans cater to every lifestyle. Choose from cozy one-bedroom retreats to spacious three-bedroom homes. Each layout harmonizes style and comfort. Interested in learning more? Our dedicated leasing team is just a message away—reach out today! ",
  "property_faqs_blurb": "At 1869 West in vibrant Pittsburgh, PA, our diverse floor plans—from cozy one-bedrooms to spacious three-bedrooms—tailor to every lifestyle. Got questions? Our FAQs page has all the insights you need to make 1869 West your new home. Uncover the details and embrace community living today!",
  "property_floorplans_blurb": "At 1869 West in Pittsburgh, PA, your ideal home awaits. Choose from spacious one, two, or three-bedroom floor plans designed with modern living in mind. Each layout harmonizes comfort and style, inviting you to embrace a vibrant lifestyle. Browse our available apartment homes today and find your perfect fit!",
  "property_gallery_blurb": "At 1869 West in vibrant Pittsburgh, PA, our thoughtfully designed one, two, and three-bedroom apartments await your personal touch. With amenities like high-speed internet, a playground, and on-site maintenance, life here is both comfortable and convenient. Picture yourself living in a community that truly enhances your lifestyle!",
  "property_interactivemap_blurb": "At 1869 West in Pittsburgh, PA, modern living meets comfort with versatile one, two, and three-bedroom floor plans. Enjoy amenities like a resident-friendly portal, pet-friendly spaces, and on-site maintenance. Navigate your future home effortlessly using our interactive community map to explore pricing and availability today!",
  "property_pets_blurb": "At 1869 West in Pittsburgh, your furry friends will feel right at home! With a welcoming environment for dogs, cats, and service animals, our pet-friendly community ensures a joyful living experience. Just remember, certain breeds are restricted, so check our pet policy as you plan your new adventure!",
  "property_referafriend_blurb": "At 1869 West in Pittsburgh, PA, we celebrate community and connection. Choose from thoughtfully designed one, two, and three-bedroom floor plans that enhance your lifestyle. Share the joy—great friends make great neighbors! Refer a friend today and let them experience the vibrant living you cherish.",
  "property_residentaccess_blurb": "At 1869 West in Pittsburgh, PA, our thoughtfully designed floor plans—ranging from cozy one bedrooms to spacious three bedrooms—cater to every lifestyle. Elevate your living experience. Access your resident portal today to conveniently pay rent, schedule maintenance, and enjoy all the perks of community life!",
  "property_reviews_blurb": "At 1869 West in Pittsburgh, residents rave about their experience, stating, \"Living here is awesome... highly recommend this place.\" With personal storage options and a pet-friendly atmosphere, our community is perfect for those just starting out. Reach out to see what our residents have to say!",
  "property_created_at": "1767380134246",
  "property_scheduletour_blurb": "At 1869 West in vibrant Pittsburgh, PA, choose from thoughtfully designed one, two, or three-bedroom floor plans tailored for your lifestyle. Schedule a tour today and immerse yourself in our stunning community! Don’t take our word for it—see what our residents love about calling 1869 West home.",
  "property_thankyou_blurb": "Thank you for reaching out to 1869 West in Pittsburgh, PA! Our diverse floor plans feature one, two, and three-bedroom layouts, perfect for any lifestyle. Stay tuned—our team will be in touch soon to help you find your ideal home in our vibrant community!",
  "property_virtualtours_blurb": "At 1869 West in Pittsburgh, PA, your dream home awaits with thoughtfully designed one to three-bedroom floor plans. Experience our vibrant community from the comfort of your couch—take a virtual tour today and imagine your future living space filled with style and warmth!",
  "property_copyright": "2026 All Rights Reserved. 1869 West",
  "property_seo_title_home": "1869 West |  Apartments in Pittsburgh, PA",
  "property_seo_description_home": "Welcome to 1869 West in Pittsburgh! Choose serene one to three-bedroom apartments with modern amenities in a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Pittsburgh, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect space at 1869 West in Pittsburgh, PA! Browse our unique one, two, and three-bedroom floor plans designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Pittsburgh, PA Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at 1869 West, Pittsburgh! Pet-friendly, with playgrounds and short-term leases. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Pittsburgh, PA",
  "property_seo_description_gallery": "Imagine life at 1869 West in Pittsburgh, PA! Enjoy modern floor plans, pet-friendly amenities, and vibrant community activities—your perfect home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | 1869 West Apartments",
  "property_seo_description_virtualtours": "Experience life at 1869 West in Pittsburgh, PA! Take a virtual tour of our stunning one, two, and three-bedroom apartments today—your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | 1869 West Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at 1869 West, Pittsburgh! Explore floor plans, amenities, and pricing on our interactive map—where comfort meets convenience!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pittsburgh, PA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of 1869 West in Pittsburgh, PA! Enjoy local favorites, parks, and exciting attractions, all just steps from your new home.",
  "property_seo_title_contact": "Contact Us | 1869 West",
  "property_seo_description_contact": "Reach out to our leasing team at 1869 West in Pittsburgh, PA! Inquire about our stylish one, two, and three-bedroom floor plans today. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Pittsburgh, PA",
  "property_seo_description_faqs": "Elevate your living at 1869 West in Pittsburgh! Uncover answers to all your questions— from floor plans to amenities—on our FAQs page today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pittsburgh, PA",
  "property_seo_description_reviews": "Join the vibrant community at 1869 West in Pittsburgh, PA. See resident reviews and discover why our one to three-bedroom apartments feel like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Pittsburgh, PA",
  "property_seo_description_applynow": "Elevate your lifestyle at 1869 West in Pittsburgh! Choose from stylish one, two, or three-bedroom homes with modern amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | 1869 West",
  "property_seo_description_residentaccess": "Unlock convenience at 1869 West in Pittsburgh! Access your resident portal to pay rent, schedule maintenance, and manage your home effortlessly!",
  "property_seo_title_referafriend": "Refer A Friend | 1869 West",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to 1869 West in Pittsburgh, PA, and enjoy exclusive perks together in our vibrant apartment community.",
  "property_seo_title_scheduletour": "Schedule a Tour | 1869 West",
  "property_seo_description_scheduletour": "Experience the charm of 1869 West in Pittsburgh. Embrace modern living and vibrant community life—schedule your personalized tour today!",
  "property_seo_title_privacy": "Privacy Policy | 1869 West",
  "property_seo_description_privacy": "At 1869 West in Pittsburgh, your privacy matters. Stay informed about how we protect your data. Dive into our privacy policy for peace of mind!",
  "property_seo_title_accessibility": "Website Accessibility | 1869 West",
  "property_seo_description_accessibility": "At 1869 West in Pittsburgh, we prioritize digital inclusion, ensuring everyone has equal access to our vibrant community. Join us in creating a welcoming home!",
  "property_seo_title_sitemap": "Sitemap | 1869 West",
  "property_seo_description_sitemap": "Navigate 1869 West in Pittsburgh with ease! Our sitemap offers a clear path to your future home and community. Discover all we have to offer today!",
  "property_seo_title_thankyou": "Thank You | 1869 West",
  "property_seo_description_thankyou": "Thank you for reaching out to 1869 West in Pittsburgh! Our team will connect with you soon to help you find your ideal apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Pittsburgh, PA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293668672",
  "amenities": [
    {
      "id": "custom_835f7990-bd4b-4ecb-b385-c83d2d8c9d12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2f4dc40-7bcd-4965-8c13-bce8acf9bd41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c859896f-8029-47bd-b0d6-3cdb061cd2dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bd3aef9-2f5b-4e99-809f-3fe24c98b4af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_891990a4-e3cc-4b5c-ad40-6d157be595f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1be4274-90e9-4ccd-97b0-48969ffe13d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67fb346e-f920-46cf-9d90-50440627b89b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42ce3a7b-b650-484a-a7f7-0ed20f413780",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06e132a2-92fb-4ba5-b3a4-0d5e7865ec5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Oak Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85d21c3a-5d39-41f9-b0ac-31c80c3cc363",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8bbd231a-b5d7-45a8-94c4-f3a5f025bd95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-Wall Carpet*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_378e4f05-f47d-4782-ab6b-4c79c4cf3533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "White Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_776492dd-a48b-468d-a135-e51ffbf080a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dccd8b70-dccd-4dd3-a144-e05d458d5b0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4ca381f8-fdb5-47c4-ace0-a61659e795e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-ac06-73f3-9e8e-8b20eb025654.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "019fd91b-ac06-73f3-9e8e-8b20eb025654",
        "storage_key": "property/6767906449166965/019fd91b-ac06-73f3-9e8e-8b20eb025654.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "false",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black appliances, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_7958_03-01-24_13_38-1920w.jpg"
    },
    {
      "id": "custom_35794cd9-caca-456b-bfb8-f45f0f4409a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd911-e641-7324-8989-e9b61469393b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and marble countertops.",
        "public_id": "019fd911-e641-7324-8989-e9b61469393b",
        "storage_key": "property/6767906449166965/019fd911-e641-7324-8989-e9b61469393b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black appliances, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_8018_04-01-24_14_17-1920w.jpg"
    },
    {
      "id": "custom_f8091197-3055-4fd6-861e-1528e70b4a3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-3bd4-77d8-8feb-4ac47b6ebde5.webp",
      "image_media": {
        "alt_text": "1869WEST Apartment Homes monument sign with leasing and management information",
        "public_id": "019fd91d-3bd4-77d8-8feb-4ac47b6ebde5",
        "storage_key": "property/6767906449166965/019fd91d-3bd4-77d8-8feb-4ac47b6ebde5.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Brick office building with a 169West sign, green lawn, and trees on a sunny day",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-11-1920w.jpg"
    },
    {
      "id": "custom_973c3bfc-3af7-4c1b-b9e1-e25ac1b11074",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-3b97-765b-a5e3-986f5f8d3906.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with seating, coffee table, and kitchen appliances.",
        "public_id": "019fd91d-3b97-765b-a5e3-986f5f8d3906",
        "storage_key": "property/6767906449166965/019fd91d-3b97-765b-a5e3-986f5f8d3906.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "Spacious living and kitchen area, perfect for relaxing and entertaining. Features comfortable seating, a coffee table, and a fully equipped kitchen.",
      "link": "false",
      "alt_text": "Open-concept living room and kitchenette with tile floors, gray seating, and a round table with flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869_West_7.13.26_1869-West-POI-02_13-07-26_12_56-1920w.jpg"
    },
    {
      "id": "custom_17340f52-be6e-4d94-a60e-bc8f975d3cb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-3f08-7696-a7b1-6e8280492ba5.webp",
      "image_media": {
        "alt_text": "Living room with a grey sofa, coffee table, rug, and dining area.",
        "public_id": "019fd91d-3f08-7696-a7b1-6e8280492ba5",
        "storage_key": "property/6767906449166965/019fd91d-3f08-7696-a7b1-6e8280492ba5.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furnishings and decor, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, coffee table, white rug, wall art, and dining area in back",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869_West_7.13.26_1869-West-POI-04_13-07-26_13_00-1920w.jpg"
    },
    {
      "id": "custom_0d38064c-ab68-4ad4-8e09-8c032d452b11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-3f30-75fd-9160-a0f11226c612.webp",
      "image_media": {
        "alt_text": "Living room and dining area in apartment.",
        "public_id": "019fd91d-3f30-75fd-9160-a0f11226c612",
        "storage_key": "property/6767906449166965/019fd91d-3f30-75fd-9160-a0f11226c612.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright living room with gray sofas, coffee table, and a bookshelf near windows and a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869_West_7.13.26_1869-West-POI-03_13-07-26_12_53-1920w.jpg"
    },
    {
      "id": "custom_3357e272-aade-4c31-a510-38bd3c88ce58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-46f6-72fd-acbf-37e84577a76a.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, and decor.",
        "public_id": "019fd91d-46f6-72fd-acbf-37e84577a76a",
        "storage_key": "property/6767906449166965/019fd91d-46f6-72fd-acbf-37e84577a76a.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Cozy bedroom with gray bed, nightstand lamp, wall art, carpet, closet doors, and a potted plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869_West_7.13.26_1869-West-POI-05_13-07-26_13_10-1920w.jpg"
    },
    {
      "id": "custom_ba0a1765-475b-4e9b-a0cc-ab2d4e76c1ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-4868-705f-a3ea-cb559043356d.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk and chair, and a leather accent chair.",
        "public_id": "019fd91d-4868-705f-a3ea-cb559043356d",
        "storage_key": "property/6767906449166965/019fd91d-4868-705f-a3ea-cb559043356d.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "A bright and airy bedroom featuring a comfortable accent chair and a modern desk setup, perfect for a home office or study space.",
      "link": "false",
      "alt_text": "Bedroom staged as an office with beige carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869_West_7.13.26_1869-West-POI-06_13-07-26_13_07-1920w.jpg"
    },
    {
      "id": "custom_f74e620b-2be1-476c-8b4c-caf926ee8497",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-49c4-772f-a9bd-43f9b705c8ab.webp",
      "image_media": {
        "alt_text": "Kitchen with white stove, gray cabinets, and a white refrigerator next to a window.",
        "public_id": "019fd91d-49c4-772f-a9bd-43f9b705c8ab",
        "storage_key": "property/6767906449166965/019fd91d-49c4-772f-a9bd-43f9b705c8ab.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "A compact kitchen featuring a gas range, stainless steel sink, ample cabinet space, and a refrigerator, with natural light streaming in from the window.",
      "link": "false",
      "alt_text": "Small kitchen with gray cabinets, white stove and fridge, and a window letting in daylight.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-01-1920w.jpg"
    },
    {
      "id": "custom_a3e6a83e-c131-40a1-a1a9-642f5e497698",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-4afc-7447-8f5e-1b5a08152e9a.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture and large windows.",
        "public_id": "019fd91d-4afc-7447-8f5e-1b5a08152e9a",
        "storage_key": "property/6767906449166965/019fd91d-4afc-7447-8f5e-1b5a08152e9a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, elegant dining set, and ample natural light from large windows, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with couch, coffee table, and TV on a wooden cabinet, next to a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_7986_03-01-24_13_35-1920w.jpg"
    },
    {
      "id": "custom_2b19d4e5-bfa4-49b7-aafb-4569a42853d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-51b4-7588-b536-68a395548170.webp",
      "image_media": {
        "alt_text": "Living and dining area with a couch, coffee table, shelf, and dining set.",
        "public_id": "019fd91d-51b4-7588-b536-68a395548170",
        "storage_key": "property/6767906449166965/019fd91d-51b4-7588-b536-68a395548170.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable couch, coffee table, ample shelving, and a modern dining set, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with beige carpet, gray walls, open to dining area with round table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/out_0bc7c6ce-cfbe-47aa-84a3-7c9aab207409-1920w.jpg"
    },
    {
      "id": "custom_a4e30831-ada1-46be-8cfc-2ab5700b835f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-52a8-7180-a552-940d2c263be4.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and entertainment center.",
        "public_id": "019fd91d-52a8-7180-a552-940d2c263be4",
        "storage_key": "property/6767906449166965/019fd91d-52a8-7180-a552-940d2c263be4.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Cozy living room with a sectional sofa, a coffee table, and a TV; natural light streams in through the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_8024_13-02-24_09_56-1920w.jpg"
    },
    {
      "id": "custom_e1edf649-0ffa-4518-8836-539908398d41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-54c7-756a-ba31-4baeedb86c91.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, TV, and bookshelf.",
        "public_id": "019fd91d-54c7-756a-ba31-4baeedb86c91",
        "storage_key": "property/6767906449166965/019fd91d-54c7-756a-ba31-4baeedb86c91.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A modern and comfortable living room featuring a plush sofa, a sleek coffee table, a wall-mounted TV, and a stylish bookshelf. This space is perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with gray sofa, wooden furniture, and potted plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_7963_03-01-24_13_30-1920w.jpg"
    },
    {
      "id": "custom_170e58db-1491-4acc-a207-806d64a68cd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-570c-7348-a78a-f89c2e4b4fab.webp",
      "image_media": {
        "alt_text": "Bedroom with bed, dresser, chair, and two windows.",
        "public_id": "019fd91d-570c-7348-a78a-f89c2e4b4fab",
        "storage_key": "property/6767906449166965/019fd91d-570c-7348-a78a-f89c2e4b4fab.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bedroom with bed, dresser, chair, two windows, and radiator. Neutral colors and natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_7994_13-02-24_10_30-1920w.jpg"
    },
    {
      "id": "custom_bf830266-6848-4d14-8466-e882a9cc6ce9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-5d5f-715e-a4ad-3d7ae1b8a2c5.webp",
      "image_media": {
        "alt_text": "View of a bedroom with a bed, dresser, and closet.",
        "public_id": "019fd91d-5d5f-715e-a4ad-3d7ae1b8a2c5",
        "storage_key": "property/6767906449166965/019fd91d-5d5f-715e-a4ad-3d7ae1b8a2c5.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample dresser storage, and a walk-in closet. Perfect for relaxation and organization.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, closet, and window. Light gray walls and light wood furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869West_DSC_8047_13-02-24_10_40-1920w.jpg"
    },
    {
      "id": "custom_e58c28c2-9e4a-4aa3-b10e-8a471c33dcab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-6001-7123-b6ce-5cab8eb07de8.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a white tub, sink, and toilet.",
        "public_id": "019fd91d-6001-7123-b6ce-5cab8eb07de8",
        "storage_key": "property/6767906449166965/019fd91d-6001-7123-b6ce-5cab8eb07de8.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a white bathtub, vanity with sink, and toilet. Includes a mirror above the vanity and a small window for natural light.",
      "link": "false",
      "alt_text": "Bright white bathroom with tub, toilet, sink vanity, mirror, and small window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-07-1920w.jpg"
    },
    {
      "id": "custom_6eae5582-ccc9-484f-95e6-d9314df6fdad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-6031-76f2-abb4-ad9b07d8acd1.webp",
      "image_media": {
        "alt_text": "Modern dining area with a blue velvet sofa and a table with four chairs.",
        "public_id": "019fd91d-6031-76f2-abb4-ad9b07d8acd1",
        "storage_key": "property/6767906449166965/019fd91d-6031-76f2-abb4-ad9b07d8acd1.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Enjoy meals or relax in this stylish dining area featuring a comfortable blue sofa and a modern table set.",
      "link": "false",
      "alt_text": "Small resident lounge with a black table and chairs, blue armchair, and framed wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-08-1920w.jpg"
    },
    {
      "id": "custom_066c52d8-1983-47bd-8e82-106fdaf35124",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-61f5-756d-94b8-babfef936857.webp",
      "image_media": {
        "alt_text": "Playground with slides and stairs surrounded by trees and a blue sky with clouds.",
        "public_id": "019fd91d-61f5-756d-94b8-babfef936857",
        "storage_key": "property/6767906449166965/019fd91d-61f5-756d-94b8-babfef936857.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Colorful playground slides and stairs on a woodchip surface, surrounded by trees under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-10-1920w.jpg"
    },
    {
      "id": "custom_e118b26f-e072-40aa-82df-6714d8c9cc44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-6815-7748-978b-2d3979dab6e5.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with green lawn and blue sky.",
        "public_id": "019fd91d-6815-7748-978b-2d3979dab6e5",
        "storage_key": "property/6767906449166965/019fd91d-6815-7748-978b-2d3979dab6e5.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Charming brick apartment buildings set against a backdrop of lush green lawns and a bright blue sky with fluffy clouds.",
      "link": "false",
      "alt_text": "Brick apartment buildings beside a large grassy courtyard under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-15-1920w.jpg"
    },
    {
      "id": "custom_c46410f9-5ea8-4cf8-85e8-7063b22f7c77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-6a55-770e-ba67-4d35362ae162.webp",
      "image_media": {
        "alt_text": "Brick apartment buildings with green lawns and mature trees.",
        "public_id": "019fd91d-6a55-770e-ba67-4d35362ae162",
        "storage_key": "property/6767906449166965/019fd91d-6a55-770e-ba67-4d35362ae162.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Enjoy the lush green spaces and mature trees surrounding these charming brick apartment buildings.",
      "link": "false",
      "alt_text": "Courtyard between red brick apartment buildings with a large green tree and grassy lawn under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-14-1920w.jpg"
    },
    {
      "id": "custom_da5ecbb0-c0b9-4689-8028-b43808e26f53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-6aa4-7413-a4b3-4c93d6274328.webp",
      "image_media": {
        "alt_text": "Brick apartment building with a paved walkway leading to the entrance, surrounded by manicured lawns and trees.",
        "public_id": "019fd91d-6aa4-7413-a4b3-4c93d6274328",
        "storage_key": "property/6767906449166965/019fd91d-6aa4-7413-a4b3-4c93d6274328.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Charming brick apartment building featuring a well-maintained exterior with lush green lawns, mature trees, and a welcoming walkway to the entrance.",
      "link": "false",
      "alt_text": "Brick apartment building with a central walkway, green lawn, and trees under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-12-1920w.jpg"
    },
    {
      "id": "custom_35d24240-6bea-4cae-8889-f0916836a38f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-6d75-7568-bd2c-1bdca1831e94.webp",
      "image_media": {
        "alt_text": "Building entrance with a path leading to the doors, surrounded by grass and trees.",
        "public_id": "019fd91d-6d75-7568-bd2c-1bdca1831e94",
        "storage_key": "property/6767906449166965/019fd91d-6d75-7568-bd2c-1bdca1831e94.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Community",
      "description": "Welcome to our community! This image shows a building entrance with a well-maintained lawn and mature trees, creating a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "Brick apartment building with a tree-lined lawn and sidewalk leading to the entrance",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-West-POI-13-1920w.jpg"
    },
    {
      "id": "custom_3907348c-693e-4be7-bd32-fdff4efc74e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-74fe-72ac-9d74-5f4f1cd59f69.webp",
      "image_media": {
        "alt_text": "Aerial view of brick apartment buildings surrounded by green trees.",
        "public_id": "019fd91d-74fe-72ac-9d74-5f4f1cd59f69",
        "storage_key": "property/6767906449166965/019fd91d-74fe-72ac-9d74-5f4f1cd59f69.webp",
        "width": 1639,
        "height": 1092
      },
      "title": "Community",
      "description": "Experience comfortable living in these well-maintained apartment buildings, nestled in a serene, tree-lined neighborhood.",
      "link": "false",
      "alt_text": "Brick apartment buildings surrounded by green trees on a hillside with parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-west-pittsburgh-pa-building-photo+%289%29-1920w.jpg"
    },
    {
      "id": "custom_4d52444e-3d25-49ff-9f28-121a7c6ce6cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-7521-76bd-875f-fb017302fe06.webp",
      "image_media": {
        "alt_text": "Aerial view of Pittsburgh skyline with rivers and bridges.",
        "public_id": "019fd91d-7521-76bd-875f-fb017302fe06",
        "storage_key": "property/6767906449166965/019fd91d-7521-76bd-875f-fb017302fe06.webp",
        "width": 1601,
        "height": 1067
      },
      "title": "Community",
      "description": "Experience the vibrant cityscape of Pittsburgh from a breathtaking aerial perspective. This image captures the iconic skyline, the confluence of its three rivers, and the majestic bridges that connect the city.",
      "link": "false",
      "alt_text": "Aerial view of Pittsburgh, PA, downtown skyline surrounded by rivers and bridges on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/a29d15e5/dms3rep/multi/opt/1869-west-pittsburgh-pa-building-photo+%2810%29-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_55c93ec7-0c37-4c19-be16-0efc294be936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Eggs R Us",
      "poi_type": "Restaurants",
      "poi_address": "2350 Noblestown Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Unfussy, family-owned breakfast & lunch establishment known for diner-style American favorites.",
      "poi_long_description": "Unfussy, family-owned breakfast & lunch establishment known for diner-style American favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-de8e-73ba-a552-39f5c02595e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91b-de8e-73ba-a552-39f5c02595e8",
        "storage_key": "property/6767906449166965/019fd91b-de8e-73ba-a552-39f5c02595e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eggs-r-us.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8392243714279946272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eggs-r-us",
      "poi_latitude": "40.42753",
      "poi_longitude": "-80.0555318",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 412-922-5828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1vGv1_2NIgRIDgpsjE9d3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9eeda83b-188a-49b5-ab78-b8e8f26d195b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Angkor - Cambodian Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "2350 Noblestown Rd # 18, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Snug outpost providing a range of classic Cambodian dishes in a simple space, plus sidewalk seating.",
      "poi_long_description": "Snug outpost providing a range of classic Cambodian dishes in a simple space, plus sidewalk seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-e74b-77a8-9ee4-a6fe1b581066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91b-e74b-77a8-9ee4-a6fe1b581066",
        "storage_key": "property/6767906449166965/019fd91b-e74b-77a8-9ee4-a6fe1b581066.webp",
        "width": 1004,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4248163956496088655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "angkor---cambodian-thai-cuisine",
      "poi_latitude": "40.4271138",
      "poi_longitude": "-80.0562528",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 412-928-8424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1vGv1_2NIgRTz6RVpyC9Do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e07d2b2f-1702-4e82-8f4e-24e957f285a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Blinky's Noble Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2350 Noblestown Rd # 11, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Casual eatery for burgers and sandwiches, as well as wings and draft beer. Friendly staff, too.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-e69b-708b-b236-ffc55ddbd331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91b-e69b-708b-b236-ffc55ddbd331",
        "storage_key": "property/6767906449166965/019fd91b-e69b-708b-b236-ffc55ddbd331.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.blinkyspgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16001838302691183132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blinkys-noble-grill--bar",
      "poi_latitude": "40.4276563",
      "poi_longitude": "-80.0551851",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 412-919-0548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3292-70f8-9c66-8cabec1ccddc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3292-70f8-9c66-8cabec1ccddc",
        "storage_key": "property/6767906449166965/019d026f-3292-70f8-9c66-8cabec1ccddc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb1vGv1_2NIgRHMolqSfzEd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e53b1df1-39d3-4e1a-a216-efbd68e31268",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Fired Up Brick Oven Tap House",
      "poi_type": "Restaurants",
      "poi_address": "2749 Noblestown Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Casual spot for pizza, wings, and mac ’n’ cheese, plus beer, cocktails, and a patio.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-e621-77ab-b7d2-7686999a7044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91b-e621-77ab-b7d2-7686999a7044",
        "storage_key": "property/6767906449166965/019fd91b-e621-77ab-b7d2-7686999a7044.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fireduptaphouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=225072699486284105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fired-up-brick-oven-tap-house",
      "poi_latitude": "40.4211472",
      "poi_longitude": "-80.0667106",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-920-7207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJveFZXZD3NIgRSamEfW2eHwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d398f36f-5d84-408e-94f5-116976a4f844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Caliente Pizza & Draft House - Crafton",
      "poi_type": "Restaurants",
      "poi_address": "288 W Steuben St, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Easygoing hangout offering pizza, burgers, subs & classic appetizers, plus a full bar & craft brews.",
      "poi_long_description": "Easygoing hangout offering pizza, burgers, subs & classic appetizers, plus a full bar & craft brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-fe8d-73da-b471-1773daaa2bfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91b-fe8d-73da-b471-1773daaa2bfd",
        "storage_key": "property/6767906449166965/019fd91b-fe8d-73da-b471-1773daaa2bfd.webp",
        "width": 1026,
        "height": 1280
      },
      "poi_business_url": "https://worldsbestpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5353520233158728131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caliente-pizza--draft-house---crafton",
      "poi_latitude": "40.4402469",
      "poi_longitude": "-80.0807655",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-685-6222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Rs45933NIgRw9lKs0mGS0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc579f89-752a-42c5-808b-e5543447ef3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Pizza Palermo (Crafton)",
      "poi_type": "Restaurants",
      "poi_address": "45 Foster Ave, Crafton, PA 15205, USA",
      "poi_short_description": "Local pizzeria chain serving pies, pasta, wings, burgers, gyros, hoagies & more in a casual space.",
      "poi_long_description": "Local pizzeria chain serving pies, pasta, wings, burgers, gyros, hoagies & more in a casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-0125-740b-9e1c-585ffa0355c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-0125-740b-9e1c-585ffa0355c7",
        "storage_key": "property/6767906449166965/019fd91c-0125-740b-9e1c-585ffa0355c7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pizzapalermo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5301284189008474855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-palermo-crafton",
      "poi_latitude": "40.4395333",
      "poi_longitude": "-80.0693811",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-922-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6Ogb272NIgR57I-6-HxkUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9219bbe8-af90-4b07-8813-0c2537c6a880",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Scoglio's USC",
      "poi_type": "Restaurants",
      "poi_address": "1580 McLaughlin Run Rd Suite 102, Pittsburgh, PA 15241, USA",
      "poi_short_description": "Pasta, seafood & other traditional Italian fare, plus wine, in a quaint, comfortable space.",
      "poi_long_description": "Pasta, seafood & other traditional Italian fare, plus wine, in a quaint, comfortable space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-faa3-747f-abe2-ddb934538161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91b-faa3-747f-abe2-ddb934538161",
        "storage_key": "property/6767906449166965/019fd91b-faa3-747f-abe2-ddb934538161.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://scogliogreentree.com/?y_source=1_MjAzMzM1NjItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=15067221892905345705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scoglios-usc",
      "poi_latitude": "40.3468679",
      "poi_longitude": "-80.0832733",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 412-921-1062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fGLtlr2NIgRqaKcZnuGGdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe79876b-a84d-452d-91be-a5f75d90b89c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Chaykhana Pittsburgh",
      "poi_type": "Restaurants",
      "poi_address": "410 S Main St, Pittsburgh, PA 15220, USA",
      "poi_short_description": "Casual eatery specializing in savory Uzbek cuisine, including lamb shank, plov, lagman, and samsa.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-0a7c-73b3-b210-2a4fb7f38c33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-0a7c-73b3-b210-2a4fb7f38c33",
        "storage_key": "property/6767906449166965/019fd91c-0a7c-73b3-b210-2a4fb7f38c33.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://chaykhanapittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17761705267856694345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chaykhana-pittsburgh",
      "poi_latitude": "40.44163289999999",
      "poi_longitude": "-80.0333917",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-922-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52d2LwD3NIgRSVzI59VAfvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b27da402-57e4-44d2-9979-7370be931d1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Ephesus Pizza",
      "poi_type": "Restaurants",
      "poi_address": "219 Fourth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Open-late eatery providing Turkish-inspired pizza & Mediterranean classics for dine-in or delivery.",
      "poi_long_description": "Open-late eatery providing Turkish-inspired pizza & Mediterranean classics for dine-in or delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-101c-732b-be38-00dbc4c12a48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-101c-732b-be38-00dbc4c12a48",
        "storage_key": "property/6767906449166965/019fd91c-101c-732b-be38-00dbc4c12a48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ephesuspizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5944954283181851093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ephesus-pizza",
      "poi_latitude": "40.4399863",
      "poi_longitude": "-80.002326",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-552-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SPCK1HxNIgR1cH9Pmy4gFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fbc8e3a4-c760-4cab-8905-76b72edc45a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "1900 Greentree Rd, Pittsburgh, PA 15220, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-1366-7658-8153-f26ba58b575a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-1366-7658-8153-f26ba58b575a",
        "storage_key": "property/6767906449166965/019fd91c-1366-7658-8153-f26ba58b575a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/pa/pittsburgh/1900-greentree-road?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202310&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=10328112973438021621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "40.39593199999999",
      "poi_longitude": "-80.067397",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-572-3480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3355-72c8-82f0-093fcd80490c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3355-72c8-82f0-093fcd80490c",
        "storage_key": "property/6767906449166965/019d026f-3355-72c8-82f0-093fcd80490c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQ3m6orz3NIgR9W_gVQfUVI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04365eb5-7358-472c-a7a7-b030ee90e17a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "971 Greentree Rd, Pittsburgh, PA 15220, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-175c-768e-931b-5b5501efa17e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-175c-768e-931b-5b5501efa17e",
        "storage_key": "property/6767906449166965/019fd91c-175c-768e-931b-5b5501efa17e.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/9223/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10834425612397076903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "40.41908",
      "poi_longitude": "-80.04566",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-922-7020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3355-72c8-82f0-093fcd80490c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3355-72c8-82f0-093fcd80490c",
        "storage_key": "property/6767906449166965/019d026f-3355-72c8-82f0-093fcd80490c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJdz2ujfD2NIgRp2FS9LCcW5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_217f5812-ac79-4c61-8159-bc49d4dddb15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Kabab House",
      "poi_type": "Restaurants",
      "poi_address": "231 E Main St, Carnegie, PA 15106, USA",
      "poi_short_description": "Afghan cooking with organic, vegetarian and halal options in a casual restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-1305-73a8-88ef-3a3a4bc0170c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-1305-73a8-88ef-3a3a4bc0170c",
        "storage_key": "property/6767906449166965/019fd91c-1305-73a8-88ef-3a3a4bc0170c.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://www.kababnow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10861772269533488782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kabab-house",
      "poi_latitude": "40.4088392",
      "poi_longitude": "-80.0849234",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-857-5130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3293-776f-8eee-96350c2de38f",
        "storage_key": "property/6767906449166965/019d026f-3293-776f-8eee-96350c2de38f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZWEOln3NIgRjma7vFTEvJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a76487bc-23d4-470a-b1cc-4bfef7b67eb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Noblestown Express Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Noblestown Rd floor 2, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-2267-750a-b206-c88a2612e350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-2267-750a-b206-c88a2612e350",
        "storage_key": "property/6767906449166965/019fd91c-2267-750a-b206-c88a2612e350.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16474147479145448610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noblestown-express-market",
      "poi_latitude": "40.4278566",
      "poi_longitude": "-80.05425489999999",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 412-458-1559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3444-778a-ac23-0892e3be30b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3444-778a-ac23-0892e3be30b2",
        "storage_key": "property/6767906449166965/019d026f-3444-778a-ac23-0892e3be30b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK95hVz_3NIgRooTcN9ntn-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6c408183-0beb-49e0-a6cf-49fa63b488a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "2269 Noblestown Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-24c1-7601-afe1-7f8a9d1fe664.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-24c1-7601-afe1-7f8a9d1fe664",
        "storage_key": "property/6767906449166965/019fd91c-24c1-7601-afe1-7f8a9d1fe664.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/pittsburgh/2269-noblestown-rd-36185?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5720405364906511533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.4282033",
      "poi_longitude": "-80.0531116",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 412-921-2258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-39e6-7660-86d8-0e31a6b89f43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-39e6-7660-86d8-0e31a6b89f43",
        "storage_key": "property/6767906449166965/019d026f-39e6-7660-86d8-0e31a6b89f43.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQYDqWfX2NIgRrcx9El_2Yk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc29e56d-a497-4f12-b2d3-86f16d27c74f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Westwood Asian Bazaar",
      "poi_type": "Shopping & Retail",
      "poi_address": "2165 Noblestown Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6517709465993507767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-asian-bazaar",
      "poi_latitude": "40.4296694",
      "poi_longitude": "-80.0530339",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3444-778a-ac23-0892e3be30b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3444-778a-ac23-0892e3be30b2",
        "storage_key": "property/6767906449166965/019d026f-3444-778a-ac23-0892e3be30b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTt4UgD3NIgRt3O-HTqOc1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a425de1-f381-4ed1-91d0-49720aab6322",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Giant Eagle Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "51 Walsh Rd Crafton, Ingram Shopping Center, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-1c2e-746c-8359-cd901b1d582a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-1c2e-746c-8359-cd901b1d582a",
        "storage_key": "property/6767906449166965/019fd91c-1c2e-746c-8359-cd901b1d582a.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.gianteagle.com/stores/pa/pittsburgh/crafton-giant-eagle/646?utm_source=google&utm_medium=organic&utm_campaign=ge_ll",
      "poi_directions_map_url": "https://maps.google.com/?cid=7584170777304046640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant-eagle-supermarket",
      "poi_latitude": "40.440628",
      "poi_longitude": "-80.07212059999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-921-4504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3444-778a-ac23-0892e3be30b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3444-778a-ac23-0892e3be30b2",
        "storage_key": "property/6767906449166965/019d026f-3444-778a-ac23-0892e3be30b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJddlQ2m32NIgRMBwbqSNjQGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9cc2e670-0d68-4825-8034-69dbb3bde83f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "70 W Steuben St, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-212b-74f5-bdcd-6872a07c2eeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-212b-74f5-bdcd-6872a07c2eeb",
        "storage_key": "property/6767906449166965/019fd91c-212b-74f5-bdcd-6872a07c2eeb.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/pittsburgh-pa-pharmacies/70-w-steuben-st-crafton-ingram-shopping-center-pittsburgh-pa-15205/storeid=4002?WT.mc_id=LS_GOOGLE_RX_4002",
      "poi_directions_map_url": "https://maps.google.com/?cid=13014189115598238610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.4390421",
      "poi_longitude": "-80.0698161",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-921-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-39e5-74c9-890f-791cad6b45ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-39e5-74c9-890f-791cad6b45ae",
        "storage_key": "property/6767906449166965/019d026f-39e5-74c9-890f-791cad6b45ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUcysyL3NIgRkvP8agywm7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d5ea45e8-c4bd-4de0-af02-2d8d0e2f0dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Noblestown Rd + Noble Manor",
      "poi_type": "Shopping & Retail",
      "poi_address": "Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7094141629103849734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noblestown-rd--noble-manor",
      "poi_latitude": "40.427084",
      "poi_longitude": "-80.05559199999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaS4ul_2NIgRBsELrTl0c2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1a5ed817-6120-455c-aca7-070129fa76ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "131 Bradford Ave, Crafton, PA 15205, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-26b8-7289-9b40-d39cde54aea9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-26b8-7289-9b40-d39cde54aea9",
        "storage_key": "property/6767906449166965/019fd91c-26b8-7289-9b40-d39cde54aea9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/pa/crafton/8103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5808441343362976968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "40.4338258",
      "poi_longitude": "-80.0668969",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 724-302-4937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3b0e-76db-91aa-126df8d33622.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3b0e-76db-91aa-126df8d33622",
        "storage_key": "property/6767906449166965/019d026f-3b0e-76db-91aa-126df8d33622.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCYK46Wj2NIgRyMzXmaC6m1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_68448eb6-d1b0-44a2-8a0a-8c4223e96fc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Crafton Ingram Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Crafton, PA 15205, USA",
      "poi_short_description": "Shopping mall with grocery stores, a bowling alley, a gym, nail salon, and other retailers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-34fa-7589-bdc2-6aba667e3904.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-34fa-7589-bdc2-6aba667e3904",
        "storage_key": "property/6767906449166965/019fd91c-34fa-7589-bdc2-6aba667e3904.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16337506535589571224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crafton-ingram-shopping-center",
      "poi_latitude": "40.44110879999999",
      "poi_longitude": "-80.07100249999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3b0e-76db-91aa-126df8d33622.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3b0e-76db-91aa-126df8d33622",
        "storage_key": "property/6767906449166965/019d026f-3b0e-76db-91aa-126df8d33622.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF7i0GnL2NIgRmGpwYaJ7uuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b9e3c11-5db9-4dfe-b029-7a3790d62522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Westwood Elementary School",
      "poi_type": "Education",
      "poi_address": "508 Shadyhill Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-3103-715e-b2f0-7682aac09e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-3103-715e-b2f0-7682aac09e98",
        "storage_key": "property/6767906449166965/019fd91c-3103-715e-b2f0-7682aac09e98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://discoverpps.org/eccwestwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989982400808506152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-elementary-school",
      "poi_latitude": "40.43196",
      "poi_longitude": "-80.0510595",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-529-6570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8zMbuov2NIgRKFOMvZIdB9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6519cac0-565b-47ed-ae0a-8f5b5e6dcdb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Crafton Elementary School",
      "poi_type": "Education",
      "poi_address": "1874 Crafton Blvd, Crafton, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-2f72-764f-a0a8-4a814b5d43b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-2f72-764f-a0a8-4a814b5d43b5",
        "storage_key": "property/6767906449166965/019fd91c-2f72-764f-a0a8-4a814b5d43b5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carlynton.k12.pa.us/crafton_elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=7096994860104545690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crafton-elementary-school",
      "poi_latitude": "40.4311182",
      "poi_longitude": "-80.0671933",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-429-2500 ext. 4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg1wnBHf2NIgRmvVNSTmXfWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_59f0a037-d38e-4ca0-9a66-1da8fdc0c7d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Beechwood Elementary School",
      "poi_type": "Education",
      "poi_address": "810 Rockland Ave, Pittsburgh, PA 15216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-2f41-751f-99ec-373ca2e6e364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-2f41-751f-99ec-373ca2e6e364",
        "storage_key": "property/6767906449166965/019fd91c-2f41-751f-99ec-373ca2e6e364.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://discoverpps.org/beechwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=6898005219519490163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beechwood-elementary-school",
      "poi_latitude": "40.4146174",
      "poi_longitude": "-80.0206113",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-529-7390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO2X6pdr2NIgRc-g_MDOjul8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d96c145a-5a2b-4ec7-939f-31e3af8d3817",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "South Hills Middle School",
      "poi_type": "Education",
      "poi_address": "595 Crane Ave, Pittsburgh, PA 15216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-3c41-7374-a3a9-58b83136c8ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-3c41-7374-a3a9-58b83136c8ff",
        "storage_key": "property/6767906449166965/019fd91c-3c41-7374-a3a9-58b83136c8ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://discoverpps.org/southhills",
      "poi_directions_map_url": "https://maps.google.com/?cid=8767356934638430205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-hills-middle-school",
      "poi_latitude": "40.4194679",
      "poi_longitude": "-80.0180304",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-529-8130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDcqnx8T2NIgR_WcuPK7oq3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fad56ee-5d14-4dbd-a4b9-948e2b73a669",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Brashear High School",
      "poi_type": "Education",
      "poi_address": "595 Crane Ave, Pittsburgh, PA 15216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-41c2-717c-92dc-33a3cca571ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-41c2-717c-92dc-33a3cca571ad",
        "storage_key": "property/6767906449166965/019fd91c-41c2-717c-92dc-33a3cca571ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pghschools.org/schools/9-12/brashear",
      "poi_directions_map_url": "https://maps.google.com/?cid=17731015831958567444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brashear-high-school",
      "poi_latitude": "40.4185975",
      "poi_longitude": "-80.0181176",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-529-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyfrkks_2NIgRFLq3yvQ4EfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_545510a9-2e4d-417f-ad9b-1c6d2146dc6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Chartiers Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "3799 Chartiers Ave, Pittsburgh, PA 15204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-3ca6-75dc-8346-4544f23ad4bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-3ca6-75dc-8346-4544f23ad4bf",
        "storage_key": "property/6767906449166965/019fd91c-3ca6-75dc-8346-4544f23ad4bf.webp",
        "width": 1089,
        "height": 1280
      },
      "poi_business_url": "https://discoverpps.org/eccchartiers",
      "poi_directions_map_url": "https://maps.google.com/?cid=4393469042769306791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chartiers-early-childhood-center",
      "poi_latitude": "40.4572854",
      "poi_longitude": "-80.0760014",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-529-6792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCVzNX-f1NIgRp6TwGdG8-Dw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_982030b0-2073-46d9-943f-7ad3a0f9cb6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Carlynton School District",
      "poi_type": "Education",
      "poi_address": "435 Kings Hwy, Carnegie, PA 15106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-48b9-736e-b21d-f51103a424d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-48b9-736e-b21d-f51103a424d8",
        "storage_key": "property/6767906449166965/019fd91c-48b9-736e-b21d-f51103a424d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carlynton.k12.pa.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16217570901862118768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carlynton-school-district",
      "poi_latitude": "40.4249764",
      "poi_longitude": "-80.0970842",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 412-429-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh91MLCH2NIgRcPUzlc9iEOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ef6cd65d-7c05-4c97-b34e-6be8b9636973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Bishop Canevin High School",
      "poi_type": "Education",
      "poi_address": "2700 Morange Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-4503-7295-8447-3e8b32292911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-4503-7295-8447-3e8b32292911",
        "storage_key": "property/6767906449166965/019fd91c-4503-7295-8447-3e8b32292911.webp",
        "width": 610,
        "height": 298
      },
      "poi_business_url": "http://www.bishopcanevin.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1489439525982581691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bishop-canevin-high-school",
      "poi_latitude": "40.4226908",
      "poi_longitude": "-80.0712369",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 412-922-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJczf4nUb2NIgRuzOehFuNqxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fad5e248-1768-4ae5-84ad-1027593f15a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Precious Angels Crafton",
      "poi_type": "Education",
      "poi_address": "81 E Crafton Ave, Crafton, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-5554-747d-8283-9264e439f25b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-5554-747d-8283-9264e439f25b",
        "storage_key": "property/6767906449166965/019fd91c-5554-747d-8283-9264e439f25b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://preciousangelscrafton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=514858604943931245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "precious-angels-crafton",
      "poi_latitude": "40.4361101",
      "poi_longitude": "-80.0638432",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-875-5117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ2aUkmX2NIgRbXc8YSwlJQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2c239f9a-72b8-4a17-b858-4549dcf4a9ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "La Roche University",
      "poi_type": "Education",
      "poi_address": "9000 Babcock Blvd, Pittsburgh, PA 15237, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-569e-7769-9046-d560928eb470.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-569e-7769-9046-d560928eb470",
        "storage_key": "property/6767906449166965/019fd91c-569e-7769-9046-d560928eb470.webp",
        "width": 1280,
        "height": 915
      },
      "poi_business_url": "https://www.laroche.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068463982658605929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-roche-university",
      "poi_latitude": "40.5684406",
      "poi_longitude": "-80.0143294",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 412-367-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsYfgKIGLNIgRaVOeEteDN1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8c920fc3-1ea5-481d-bc2c-cb81b9ec38c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Row House Cinema - Lawrenceville",
      "poi_type": "Entertainment",
      "poi_address": "4115 Butler St, Pittsburgh, PA 15201, USA",
      "poi_short_description": "Independent cinema featuring classic and new films, plus craft beer and other drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-4d00-7428-9d83-2c997dee9657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-4d00-7428-9d83-2c997dee9657",
        "storage_key": "property/6767906449166965/019fd91c-4d00-7428-9d83-2c997dee9657.webp",
        "width": 699,
        "height": 466
      },
      "poi_business_url": "https://rowhousecinemas.com/lawrenceville",
      "poi_directions_map_url": "https://maps.google.com/?cid=15044726500483054512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "row-house-cinema---lawrenceville",
      "poi_latitude": "40.469939",
      "poi_longitude": "-79.96106499999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-904-3225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4e-7578-8e63-5d28b5a822cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4e-7578-8e63-5d28b5a822cd",
        "storage_key": "property/6767906449166965/019d026f-3f4e-7578-8e63-5d28b5a822cd.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3lfn03yNIgRsLsytAqbydA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dfda69cf-655c-4d2b-9cad-2a1fee347f1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Manor Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1729 Murray Ave, Pittsburgh, PA 15217, USA",
      "poi_short_description": "Landmark theater featuring independent films & documentaries, plus a cocktail bar with casual fare.",
      "poi_long_description": "Landmark theater featuring independent films & documentaries, plus a cocktail bar with casual fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-64cd-7558-b471-a1f14a3042e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-64cd-7558-b471-a1f14a3042e3",
        "storage_key": "property/6767906449166965/019fd91c-64cd-7558-b471-a1f14a3042e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.manorpgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9950737258870902732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manor-theatre",
      "poi_latitude": "40.4371792",
      "poi_longitude": "-79.9228073",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 412-422-9851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4e-7578-8e63-5d28b5a822cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4e-7578-8e63-5d28b5a822cd",
        "storage_key": "property/6767906449166965/019d026f-3f4e-7578-8e63-5d28b5a822cd.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJC67EZP_xNIgRzI8-0NAeGIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4812d852-4dad-422f-b12a-7b6fe32f85d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Mr. Smalls Theatre",
      "poi_type": "Entertainment",
      "poi_address": "400 Lincoln Ave, Millvale, PA 15209, USA",
      "poi_short_description": "Multi-purpose space has a concert mainstage, recording studios, a skate park & artists' Rock Hostel.",
      "poi_long_description": "Multi-purpose space has a concert mainstage, recording studios, a skate park & artists' Rock Hostel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-57a5-740c-b912-9bf060ff3917.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-57a5-740c-b912-9bf060ff3917",
        "storage_key": "property/6767906449166965/019fd91c-57a5-740c-b912-9bf060ff3917.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mrsmalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17219948855393256165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-smalls-theatre",
      "poi_latitude": "40.4808185",
      "poi_longitude": "-79.97224949999999",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 412-821-4447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZ5sNKjzNIgR5QIcsD-M-e4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06efb8d0-a0c2-423d-b2a4-c5666e5554dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Stage AE",
      "poi_type": "Entertainment",
      "poi_address": "400 N Shr Dr, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Rock concert venue with a vast interior space & balcony also has outdoor seating  & an indoor club.",
      "poi_long_description": "Rock concert venue with a vast interior space & balcony also has outdoor seating  & an indoor club.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-6901-73cd-88aa-b02743768d29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-6901-73cd-88aa-b02743768d29",
        "storage_key": "property/6767906449166965/019fd91c-6901-73cd-88aa-b02743768d29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.stageae.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8895307685488619309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stage-ae",
      "poi_latitude": "40.4461361",
      "poi_longitude": "-80.0122828",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-229-5483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydWFLQD0NIgRLe9Z6TV7cns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_77fd542d-66e3-408a-8e7b-575ae67bbf44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "The Andy Warhol Museum",
      "poi_type": "Entertainment",
      "poi_address": "117 Sandusky St, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Museum where Warhol's art is the star & the inspiration for new works, performances & lectures.",
      "poi_long_description": "Museum where Warhol's art is the star & the inspiration for new works, performances & lectures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-72a3-708c-a29a-5d3c2b109620.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-72a3-708c-a29a-5d3c2b109620",
        "storage_key": "property/6767906449166965/019fd91c-72a3-708c-a29a-5d3c2b109620.webp",
        "width": 1110,
        "height": 1280
      },
      "poi_business_url": "https://www.warhol.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14628228251209049136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-andy-warhol-museum",
      "poi_latitude": "40.4483755",
      "poi_longitude": "-80.0024907",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-237-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f89-728a-93ae-8ffbad1a72d4",
        "storage_key": "property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqofxNIgRMCSmPhfoAcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac750131-a41c-49c7-b9dc-c925778eafee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Mattress Factory Contemporary Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "509 Jacksonia St, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Contemporary art museum features playful room-sized installations created by in-residence artists.",
      "poi_long_description": "Contemporary art museum features playful room-sized installations created by in-residence artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-61f6-7210-a4a7-b1552ea3030c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-61f6-7210-a4a7-b1552ea3030c",
        "storage_key": "property/6767906449166965/019fd91c-61f6-7210-a4a7-b1552ea3030c.webp",
        "width": 1240,
        "height": 916
      },
      "poi_business_url": "http://mattress.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5118079166239075956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mattress-factory-contemporary-art-museum",
      "poi_latitude": "40.4572191",
      "poi_longitude": "-80.0124212",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-231-3169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f89-728a-93ae-8ffbad1a72d4",
        "storage_key": "property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfpr7Qj0NIgRdO4BjOIRB0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8b4ea8f-6574-4456-a36b-b7932c2e7020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Carnegie Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "4400 Forbes Ave, Pittsburgh, PA 15213, USA",
      "poi_short_description": "Fossils of dinosaurs & sea creatures, plus minerals & an open paleontology lab, in a grand building.",
      "poi_long_description": "Fossils of dinosaurs & sea creatures, plus minerals & an open paleontology lab, in a grand building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-7a83-757a-947f-d7ce6557d9e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-7a83-757a-947f-d7ce6557d9e2",
        "storage_key": "property/6767906449166965/019fd91c-7a83-757a-947f-d7ce6557d9e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://carnegiemnh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2490811425073383080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carnegie-museum-of-natural-history",
      "poi_latitude": "40.4433215",
      "poi_longitude": "-79.949974",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-622-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f89-728a-93ae-8ffbad1a72d4",
        "storage_key": "property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRKe38LzNIgRqMb7UcsjkSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d135a8f-f11c-4ba1-94cf-0e018cddb790",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Phipps Conservatory and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "1 Schenley Dr, Pittsburgh, PA 15213, USA",
      "poi_short_description": "Schenley Park's horticulture hub features botanical gardens & a steel-&-glass Victorian greenhouse.",
      "poi_long_description": "Schenley Park's horticulture hub features botanical gardens & a steel-&-glass Victorian greenhouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-6e79-73fc-8c73-426c1fe52563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-6e79-73fc-8c73-426c1fe52563",
        "storage_key": "property/6767906449166965/019fd91c-6e79-73fc-8c73-426c1fe52563.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phipps.conservatory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2927673893487789581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phipps-conservatory-and-botanical-gardens",
      "poi_latitude": "40.4390155",
      "poi_longitude": "-79.947951",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-622-6914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZlC-InxNIgRDUaGB-UvoSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_efe8038a-dd8c-4711-8392-2d17e9832f4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Kamin Science Center",
      "poi_type": "Entertainment",
      "poi_address": "1 Allegheny Ave, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Museum & research center offers science-related exhibits, a planetarium, live shows & kids programs.",
      "poi_long_description": "Museum & research center offers science-related exhibits, a planetarium, live shows & kids programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-7cc7-745a-b5b6-ad0d97369cfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-7cc7-745a-b5b6-ad0d97369cfc",
        "storage_key": "property/6767906449166965/019fd91c-7cc7-745a-b5b6-ad0d97369cfc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kaminsciencecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15799696986910244856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kamin-science-center",
      "poi_latitude": "40.4456828",
      "poi_longitude": "-80.01818519999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-237-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f89-728a-93ae-8ffbad1a72d4",
        "storage_key": "property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqofxNIgR-D-Y_7LMQ9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6728e2ed-936f-4796-8f93-2a98cf648a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Children's Museum of Pittsburgh",
      "poi_type": "Entertainment",
      "poi_address": "10 Children's Way, Pittsburgh, PA 15212, USA",
      "poi_short_description": "Children's museum for hands-on learning offers play areas, educational exhibits & puppet shows.",
      "poi_long_description": "Children's museum for hands-on learning offers play areas, educational exhibits & puppet shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-795a-77f6-846a-9710992da4ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-795a-77f6-846a-9710992da4ca",
        "storage_key": "property/6767906449166965/019fd91c-795a-77f6-846a-9710992da4ca.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.pittsburghkids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14562065122464082294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-pittsburgh",
      "poi_latitude": "40.4528353",
      "poi_longitude": "-80.0064158",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 412-322-5058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f89-728a-93ae-8ffbad1a72d4",
        "storage_key": "property/6767906449166965/019d026f-3f89-728a-93ae-8ffbad1a72d4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSw4X_jzNIgRdqmTZBPZFso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac5e10e1-31dd-424d-9628-dd5f42492f52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "AHN Primary Care Crafton",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Walsh Rd Suite 0, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-7acc-7171-8508-8593b65f4980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-7acc-7171-8508-8593b65f4980",
        "storage_key": "property/6767906449166965/019fd91c-7acc-7171-8508-8593b65f4980.webp",
        "width": 698,
        "height": 698
      },
      "poi_business_url": "https://www.ahn.org/location-search/ahn-primary-care-crafton-247530?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12848648918792439536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahn-primary-care-crafton",
      "poi_latitude": "40.43908",
      "poi_longitude": "-80.07065999999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-922-3773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9eT23W32NIgR8IZU2B2ST7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c8be3e52-8a57-4375-a506-8a81a6eb42b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "UPMC-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "6500 Steubenville Pike, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-810d-77bc-80b3-d4305adbf868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-810d-77bc-80b3-d4305adbf868",
        "storage_key": "property/6767906449166965/019fd91c-810d-77bc-80b3-d4305adbf868.webp",
        "width": 778,
        "height": 438
      },
      "poi_business_url": "https://www.gohealthuc.com/upmc/locations/robinson-court?utm_source=gmb&utm_medium=organic&utm_content=upmc-robinsoncourt",
      "poi_directions_map_url": "https://maps.google.com/?cid=5211827919046653255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-gohealth-urgent-care",
      "poi_latitude": "40.449191",
      "poi_longitude": "-80.1595806",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-275-0191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc584WjdZNIgRRzU9AeEhVEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e6e806f9-af62-4dfd-8381-2442b0a7cd70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Giant Eagle Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2103 Noblestown Rd, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-8dfa-71df-a642-d2302bbb3a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-8dfa-71df-a642-d2302bbb3a10",
        "storage_key": "property/6767906449166965/019fd91c-8dfa-71df-a642-d2302bbb3a10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14498757830287552637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant-eagle-pharmacy",
      "poi_latitude": "40.43054830000001",
      "poi_longitude": "-80.0521146",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 412-921-1545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-39e5-74c9-890f-791cad6b45ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-39e5-74c9-890f-791cad6b45ae",
        "storage_key": "property/6767906449166965/019d026f-39e5-74c9-890f-791cad6b45ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0UaCQD3NIgRffCzzm3vNck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d26c1249-d78e-427b-abb7-dda6b7ee5111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "70 W Steuben St, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-212b-74f5-bdcd-6872a07c2eeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-212b-74f5-bdcd-6872a07c2eeb",
        "storage_key": "property/6767906449166965/019fd91c-212b-74f5-bdcd-6872a07c2eeb.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/pittsburgh-pa-pharmacies/70-w-steuben-st-crafton-ingram-shopping-center-pittsburgh-pa-15205/storeid=4002?WT.mc_id=LS_GOOGLE_RX_4002",
      "poi_directions_map_url": "https://maps.google.com/?cid=13014189115598238610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.4390421",
      "poi_longitude": "-80.0698161",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-921-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-39e5-74c9-890f-791cad6b45ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-39e5-74c9-890f-791cad6b45ae",
        "storage_key": "property/6767906449166965/019d026f-39e5-74c9-890f-791cad6b45ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUcysyL3NIgRkvP8agywm7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44a301a4-68b1-4af8-9fd0-49d8e188f58e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "112 W Steuben St, Crafton, PA 15205, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-8df1-753f-96c1-2bf063e26390.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-8df1-753f-96c1-2bf063e26390",
        "storage_key": "property/6767906449166965/019fd91c-8df1-753f-96c1-2bf063e26390.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-112+w+steuben+st-crafton-pa-15205/id=1034",
      "poi_directions_map_url": "https://maps.google.com/?cid=3879216002852235060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.4394126",
      "poi_longitude": "-80.07244299999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-928-0146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfI5om32NIgRNKcE0Wa-1TU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1bba25b4-e565-47e9-988f-8a569fe187cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Fortitude Fitness Pittsburgh",
      "poi_type": "Health and Wellness",
      "poi_address": "345 Vista Park Dr building 3, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-8570-77f8-896e-ff68b8aef008.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-8570-77f8-896e-ff68b8aef008",
        "storage_key": "property/6767906449166965/019fd91c-8570-77f8-896e-ff68b8aef008.webp",
        "width": 968,
        "height": 532
      },
      "poi_business_url": "http://fortitudefitnesspittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=945354674012516365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fortitude-fitness-pittsburgh",
      "poi_latitude": "40.4329307",
      "poi_longitude": "-80.135581",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-659-8301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBec9fuhYNIgRDXBFOxGTHg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_930c5c9b-335e-431d-8d3d-13f15382e334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Platinum Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "Two Parkway Center, 875 Greentree Rd, Pittsburgh, PA 15220, USA",
      "poi_short_description": "No-frills fitness center featuring free weights and cardio machines as well as tanning beds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-8ab8-71d8-9398-62592bbecdee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-8ab8-71d8-9398-62592bbecdee",
        "storage_key": "property/6767906449166965/019fd91c-8ab8-71d8-9398-62592bbecdee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.platinumfitnesscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18421339409105020509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "platinum-fitness-center",
      "poi_latitude": "40.4251166",
      "poi_longitude": "-80.03877399999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 412-921-7074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2SvBvIr2NIgRXeablpe-pf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_81decaf0-acff-45d1-bf69-637b0ed2d5f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Wright's Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "27 Foster Ave, Crafton, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-9736-763e-b588-db6f1daef89a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-9736-763e-b588-db6f1daef89a",
        "storage_key": "property/6767906449166965/019fd91c-9736-763e-b588-db6f1daef89a.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "http://www.wrightsgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=378683517441325722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wrights-gym",
      "poi_latitude": "40.4405224",
      "poi_longitude": "-80.0694858",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 412-921-1530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU-eFbm72NIgRmrpiG6daQQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27d2d4ee-3c2d-4137-bbb8-f70b6a30a14c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Soul to Sole integrative healing therapies",
      "poi_type": "Health and Wellness",
      "poi_address": "14 E Crafton Ave, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-a974-740a-a852-dc34c0c0d311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-a974-740a-a852-dc34c0c0d311",
        "storage_key": "property/6767906449166965/019fd91c-a974-740a-a852-dc34c0c0d311.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666835479219058469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soul-to-sole-integrative-healing-therapies",
      "poi_latitude": "40.4356371",
      "poi_longitude": "-80.06679100000001",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoxMo6-H5NIgRJbe6TJB-TOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba7e9652-d26d-4520-ad79-68ae4515cd32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Hess Physical Therapy -Crafton",
      "poi_type": "Health and Wellness",
      "poi_address": "37 Foster Ave, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-9f97-70dc-a9ab-0371552e7565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-9f97-70dc-a9ab-0371552e7565",
        "storage_key": "property/6767906449166965/019fd91c-9f97-70dc-a9ab-0371552e7565.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hesspt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10040601174035839971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hess-physical-therapy--crafton",
      "poi_latitude": "40.4396511",
      "poi_longitude": "-80.06974699999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 412-458-3445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2y5wY3H2NIgR47vGBZJhV4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4ebffffe-6269-4057-964f-62ec433fee6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Westwood Swimming Pool",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Guyland St, Pittsburgh, PA 15205, USA",
      "poi_short_description": "Public swimming pool with a concession stand offering clean facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-a9fd-71d7-8e2a-7014f9491b3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-a9fd-71d7-8e2a-7014f9491b3c",
        "storage_key": "property/6767906449166965/019fd91c-a9fd-71d7-8e2a-7014f9491b3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11447548455552057801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-swimming-pool",
      "poi_latitude": "40.4309917",
      "poi_longitude": "-80.0498295",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 412-937-3061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5j71ov2NIgRyYFAKqvc3Z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5043b77f-b75a-4436-9ec3-e77de3a38454",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Crafton Heights Tot Lot",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Preston St & Crotzer Ave, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pittsburghpa.gov/citiparks/park-facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=3307289511141965058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crafton-heights-tot-lot",
      "poi_latitude": "40.4360796",
      "poi_longitude": "-80.0566067",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoU7crWP2NIgRAv39oEna5S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ff005a9-85e4-41fd-88ba-0155fb6dc2ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Dunbar Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1213 Clairhaven St, Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pittsburghpa.gov/citiparks/our-parks.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7105874342262943210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunbar-park",
      "poi_latitude": "40.4387589",
      "poi_longitude": "-80.0523352",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJke1fdwD3NIgR6i0l1RAjnWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b1631ce-10a7-4de9-9da3-20a9141fd940",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Pittsburgh Botanic Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "799 Pinkerton Run Rd, Oakdale, PA 15071, USA",
      "poi_short_description": "Themed gardens, a dogwood meadow & woodlands with a lotus pond, laced with walking trails.",
      "poi_long_description": "Themed gardens, a dogwood meadow & woodlands with a lotus pond, laced with walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-a2af-77d9-9ed9-d5f82615fbe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-a2af-77d9-9ed9-d5f82615fbe9",
        "storage_key": "property/6767906449166965/019fd91c-a2af-77d9-9ed9-d5f82615fbe9.webp",
        "width": 1280,
        "height": 811
      },
      "poi_business_url": "https://pittsburghbotanicgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10214162727047615722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-botanic-garden",
      "poi_latitude": "40.4174744",
      "poi_longitude": "-80.1719597",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-444-4464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXiabp5ZNIgR6lS1H-L-v40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad6d5f09-3c2a-47bd-b54a-75be1d3de27b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Chartiers Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Chartiers Playground, 3793 Chartiers Ave, Pittsburgh, PA 15204, USA",
      "poi_short_description": "Splash pad for youngsters plus a playground and picnic area for cookouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-c235-714d-8846-677684141dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-c235-714d-8846-677684141dd3",
        "storage_key": "property/6767906449166965/019fd91c-c235-714d-8846-677684141dd3.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://engage.pittsburghpa.gov/chartiers",
      "poi_directions_map_url": "https://maps.google.com/?cid=326314107773248534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chartiers-playground",
      "poi_latitude": "40.4567331",
      "poi_longitude": "-80.07409659999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqxt31NIgRFuQFv_NMhwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a97bdcc0-58af-4861-b530-f4000a45cdb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "West End Overlook Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Marlow St, Pittsburgh, PA 15205, USA",
      "poi_short_description": "This park by the Ohio River offers city views & is a popular spot for summer movies & fireworks.",
      "poi_long_description": "This park by the Ohio River offers city views & is a popular spot for summer movies & fireworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-b6e7-720d-adbb-5b510c8bd9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-b6e7-720d-adbb-5b510c8bd9ca",
        "storage_key": "property/6767906449166965/019fd91c-b6e7-720d-adbb-5b510c8bd9ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://registerparks.pittsburghpa.gov/ViewFacilityDetails.aspx?Fid=43&Rid=89",
      "poi_directions_map_url": "https://maps.google.com/?cid=9471868366899742919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-end-overlook-park",
      "poi_latitude": "40.445656",
      "poi_longitude": "-80.03375489999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-255-2539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1nHvyD0NIgRx4hReBjWcoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1f64b95a-d4a7-445d-9493-cc3920e3a47e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Esplen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3150 Esplen St, Pittsburgh, PA 15204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298345272084191760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "esplen-park",
      "poi_latitude": "40.4606697",
      "poi_longitude": "-80.0508291",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-P9zL0NIgRENrGCdlc5R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b2fef960-b802-4be0-905c-50ee8b553d3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Sheraden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Adon St, Pittsburgh, PA 15204, USA",
      "poi_short_description": "Park with picnic tables, a playground, a basketball court, and tennis.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-c6b6-76fb-be5f-44cedfb194ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-c6b6-76fb-be5f-44cedfb194ef",
        "storage_key": "property/6767906449166965/019fd91c-c6b6-76fb-be5f-44cedfb194ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pittsburghpa.gov/citiparks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3351754302563224652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheraden-park",
      "poi_latitude": "40.4587892",
      "poi_longitude": "-80.05855559999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-937-3054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9X67NH1NIgRTAyrosfSgy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d9e0c676-c813-4c73-905e-0bf787dd1f4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Emerald View Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bailey Ave, Pittsburgh, PA 15211, USA",
      "poi_short_description": "Hilltop 257-acre park on a former coal mining area with trails, woodland & play & picnic areas.",
      "poi_long_description": "Hilltop 257-acre park on a former coal mining area with trails, woodland & play & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-b6f4-743f-8012-bc68e3c70a3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-b6f4-743f-8012-bc68e3c70a3b",
        "storage_key": "property/6767906449166965/019fd91c-b6f4-743f-8012-bc68e3c70a3b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://pittsburghparks.org/explore-your-parks/regional-parks/emerald-view-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17658037259417345984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerald-view-park",
      "poi_latitude": "40.4269699",
      "poi_longitude": "-79.99699439999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-682-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3fc2-7155-b75c-6da1d86877e1",
        "storage_key": "property/6767906449166965/019d026f-3fc2-7155-b75c-6da1d86877e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW805AkzxNIgRwN8uxlTzDfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4206853f-7976-4d11-a59e-cff1292331a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Sheraden Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1628 Chartiers Ave, Pittsburgh, PA 15204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rideprt.org/park-and-ride-lots/park-and-rides/sheraden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10193907156685630939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheraden-park-and-ride",
      "poi_latitude": "40.452071",
      "poi_longitude": "-80.051672",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-44f2-772c-bcea-40b0e31d8c4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-44f2-772c-bcea-40b0e31d8c4b",
        "storage_key": "property/6767906449166965/019d026f-44f2-772c-bcea-40b0e31d8c4b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTddJgD1NIgR2y2Po4wIeI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7a4236fd-28e7-4ff1-b598-0bed8c88f3b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "West Busway + Crafton Station C",
      "poi_type": "Transportation & Transit",
      "poi_address": "Crafton, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-cc0c-7377-bd52-7eb753a8b521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-cc0c-7377-bd52-7eb753a8b521",
        "storage_key": "property/6767906449166965/019fd91c-cc0c-7377-bd52-7eb753a8b521.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11559540612549154621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-busway--crafton-station-c",
      "poi_latitude": "40.435745",
      "poi_longitude": "-80.067571",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-44f8-7149-b6c5-1b9c0c1a554a",
        "storage_key": "property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVDI2G72NIgRPZexKfG8a6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66bb2383-2967-4e04-b128-ed627287ce7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "West Busway + Ingram Station C",
      "poi_type": "Transportation & Transit",
      "poi_address": "Ingram, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12186309933621239324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-busway--ingram-station-c",
      "poi_latitude": "40.44388379999999",
      "poi_longitude": "-80.0658235",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-44f8-7149-b6c5-1b9c0c1a554a",
        "storage_key": "property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJuw1QvnD2NIgRHN5OnFF4Hqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_53f29d48-e27f-4c8f-a034-bfa78266b821",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "West Busway + Idlewood Station A",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pittsburgh, PA 15205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-cc8c-72df-910c-18b51df46981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-cc8c-72df-910c-18b51df46981",
        "storage_key": "property/6767906449166965/019fd91c-cc8c-72df-910c-18b51df46981.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12794027751148048620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-busway--idlewood-station-a",
      "poi_latitude": "40.426101",
      "poi_longitude": "-80.072903",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-44f8-7149-b6c5-1b9c0c1a554a",
        "storage_key": "property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSEJI0H2NIgR7FCrOXSEjbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c93274ca-c292-4b05-8c53-24eba1b3079b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "West Busway + Bell Station C",
      "poi_type": "Transportation & Transit",
      "poi_address": "Carnegie, PA 15106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-dde1-7279-817b-3c45db62e811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-dde1-7279-817b-3c45db62e811",
        "storage_key": "property/6767906449166965/019fd91c-dde1-7279-817b-3c45db62e811.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9551575325712628158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-busway--bell-station-c",
      "poi_latitude": "40.4156",
      "poi_longitude": "-80.082726",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-44f8-7149-b6c5-1b9c0c1a554a",
        "storage_key": "property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSOq5zP2NIgRvrl8_iYDjoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b1456788-1930-4827-b8c9-afe74fd79f69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "West Busway + Carnegie Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Carnegie, PA 15106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-e10a-7375-b68f-eb47a7ab1082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-e10a-7375-b68f-eb47a7ab1082",
        "storage_key": "property/6767906449166965/019fd91c-e10a-7375-b68f-eb47a7ab1082.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7048211388797929175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-busway--carnegie-station",
      "poi_latitude": "40.406091",
      "poi_longitude": "-80.090234",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-44f8-7149-b6c5-1b9c0c1a554a",
        "storage_key": "property/6767906449166965/019d026f-44f8-7149-b6c5-1b9c0c1a554a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSJScNH3NIgR18YpQ-pG0GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_876434e4-907d-44b4-981b-6ff08fa72a77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Pittsburgh International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1000 Airport Blvd, Pittsburgh, PA 15231, USA",
      "poi_short_description": "Airport featuring free WiFi plus art exhibits & a huge model of a Tyrannosaurus rex.",
      "poi_long_description": "Airport featuring free WiFi plus art exhibits & a huge model of a Tyrannosaurus rex.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-d53c-7129-9606-f8b01b216b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-d53c-7129-9606-f8b01b216b25",
        "storage_key": "property/6767906449166965/019fd91c-d53c-7129-9606-f8b01b216b25.webp",
        "width": 1200,
        "height": 850
      },
      "poi_business_url": "https://flypittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14416628294299238233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-international-airport",
      "poi_latitude": "40.4928544",
      "poi_longitude": "-80.2372942",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 412-472-3525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-450d-7468-8bbe-0fc36eaac533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-450d-7468-8bbe-0fc36eaac533",
        "storage_key": "property/6767906449166965/019d026f-450d-7468-8bbe-0fc36eaac533.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1vNTsNcNIgRWT-NFA0nEsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8eab3a8f-f4da-4ef7-b85e-590de712d3a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "PPG Industries Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 PPG Pl, Pittsburgh, PA 15222, USA",
      "poi_short_description": "Skyscraper resembling a castle turret, covered in reflective glass & set on a plaza with fountains.",
      "poi_long_description": "Skyscraper resembling a castle turret, covered in reflective glass & set on a plaza with fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-e3f0-752b-9ab9-9d703c74993b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-e3f0-752b-9ab9-9d703c74993b",
        "storage_key": "property/6767906449166965/019fd91c-e3f0-752b-9ab9-9d703c74993b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ppg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206431020168479959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppg-industries-inc",
      "poi_latitude": "40.4398819",
      "poi_longitude": "-80.0034788",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 412-434-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZy_A1TxNIgR14RHLjzQw38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b829724-5212-4114-b141-87ef5a0dc5ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "The PNC Financial Services Group, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "249 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-eba0-7199-9eab-5e3124118090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-eba0-7199-9eab-5e3124118090",
        "storage_key": "property/6767906449166965/019fd91c-eba0-7199-9eab-5e3124118090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pnc.com/en/about-pnc.html?lnksrc=corp-listing-website-google",
      "poi_directions_map_url": "https://maps.google.com/?cid=2285913630800081943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pnc-financial-services-group-inc",
      "poi_latitude": "40.4412252",
      "poi_longitude": "-80.00050499999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-726-2265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy8hn71bxNIgRF_QP_1UyuR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a051e6c4-cfd9-4f72-b716-9268b7fad08c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Highmark Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120 Fifth Ave, Pittsburgh, PA 15222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-f4cd-7019-b4b6-a86b9556063b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-f4cd-7019-b4b6-a86b9556063b",
        "storage_key": "property/6767906449166965/019fd91c-f4cd-7019-b4b6-a86b9556063b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.highmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15507996705669340876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highmark-corporate-headquarters",
      "poi_latitude": "40.4419235",
      "poi_longitude": "-80.00317319999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 412-544-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3a7d-71c8-bf18-d0b6e5afe687",
        "storage_key": "property/6767906449166965/019d026f-3a7d-71c8-bf18-d0b6e5afe687.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZ51f1bxNIgRzF5Zw9Z4N9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a597d7bc-8d58-4bdf-882c-d3f0d804a0c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Allegheny County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "436 Grant St, Pittsburgh, PA 15219, USA",
      "poi_short_description": "Landmark built in romanesque revival style, featuring turreted towers & an interior courtyard.",
      "poi_long_description": "Landmark built in romanesque revival style, featuring turreted towers & an interior courtyard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-fcc2-743d-b48d-59db603deb39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-fcc2-743d-b48d-59db603deb39",
        "storage_key": "property/6767906449166965/019fd91c-fcc2-743d-b48d-59db603deb39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alleghenycourts.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5295232706788827058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allegheny-county-courthouse",
      "poi_latitude": "40.4388408",
      "poi_longitude": "-79.99593150000001",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 412-350-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-45c7-75ae-aeed-5d5f163a2e15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-45c7-75ae-aeed-5d5f163a2e15",
        "storage_key": "property/6767906449166965/019d026f-45c7-75ae-aeed-5d5f163a2e15.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0z4HlrxNIgRsp8taxdyfEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ee70620-d9b4-4d7c-b013-a92970321dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Pittsburgh International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Airport Blvd, Pittsburgh, PA 15231, USA",
      "poi_short_description": "Airport featuring free WiFi plus art exhibits & a huge model of a Tyrannosaurus rex.",
      "poi_long_description": "Airport featuring free WiFi plus art exhibits & a huge model of a Tyrannosaurus rex.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-d53c-7129-9606-f8b01b216b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-d53c-7129-9606-f8b01b216b25",
        "storage_key": "property/6767906449166965/019fd91c-d53c-7129-9606-f8b01b216b25.webp",
        "width": 1200,
        "height": 850
      },
      "poi_business_url": "https://flypittsburgh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14416628294299238233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittsburgh-international-airport",
      "poi_latitude": "40.4928544",
      "poi_longitude": "-80.2372942",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 412-472-3525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-450d-7468-8bbe-0fc36eaac533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-450d-7468-8bbe-0fc36eaac533",
        "storage_key": "property/6767906449166965/019d026f-450d-7468-8bbe-0fc36eaac533.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1vNTsNcNIgRWT-NFA0nEsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_386d5296-4f9c-4687-8b7c-883e391fc4f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "University of Pittsburgh",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4200 Fifth Ave, Pittsburgh, PA 15260, USA",
      "poi_short_description": "Founded in 1787, this research university is known for health sciences, education & engineering.",
      "poi_long_description": "Founded in 1787, this research university is known for health sciences, education & engineering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-0578-71d8-b7cd-8571355344cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91d-0578-71d8-b7cd-8571355344cd",
        "storage_key": "property/6767906449166965/019fd91d-0578-71d8-b7cd-8571355344cd.webp",
        "width": 923,
        "height": 1280
      },
      "poi_business_url": "https://www.pitt.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5972082850565172495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-pittsburgh",
      "poi_latitude": "40.4444842",
      "poi_longitude": "-79.9612831",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 412-624-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH_Fa2SvyNIgRD60jDbYZ4VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_39fba013-3724-4072-b3f1-9efd78af5a5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "Carnegie Mellon University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 Forbes Ave, Pittsburgh, PA 15213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-0e07-721f-aa54-f24a32b4565d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91d-0e07-721f-aa54-f24a32b4565d",
        "storage_key": "property/6767906449166965/019fd91d-0e07-721f-aa54-f24a32b4565d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cmu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9831757410451380980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carnegie-mellon-university",
      "poi_latitude": "40.4432027",
      "poi_longitude": "-79.9428499",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 412-268-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-3f4d-712f-a66c-eb98f1c4414c",
        "storage_key": "property/6767906449166965/019d026f-3f4d-712f-a66c-eb98f1c4414c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5pnWB_yNIgR9NrEH0ZrcYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_daaaf819-65c0-4075-ac22-8037c2145693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "UPMC Presbyterian",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Lothrop St, Pittsburgh, PA 15213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91c-fd8e-7159-879c-30a3c9b31108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91c-fd8e-7159-879c-30a3c9b31108",
        "storage_key": "property/6767906449166965/019fd91c-fd8e-7159-879c-30a3c9b31108.webp",
        "width": 450,
        "height": 337
      },
      "poi_business_url": "https://www.upmc.com/locations/hospitals/presbyterian?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=hospital-swpa-upmc-presbyterian",
      "poi_directions_map_url": "https://maps.google.com/?cid=13524001783967806452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-presbyterian",
      "poi_latitude": "40.4420854",
      "poi_longitude": "-79.96079139999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 412-647-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-497e-7399-a0dd-cb79991b5d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-497e-7399-a0dd-cb79991b5d64",
        "storage_key": "property/6767906449166965/019d026f-497e-7399-a0dd-cb79991b5d64.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5g2AybyNIgR9HMmI_jnrrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3496fb61-5820-493f-906b-0e428aad92ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "UPMC Children's Hospital of Pittsburgh",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4401 Penn Ave, Pittsburgh, PA 15224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-0681-77bc-9f3d-1306ca82feea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91d-0681-77bc-9f3d-1306ca82feea",
        "storage_key": "property/6767906449166965/019fd91d-0681-77bc-9f3d-1306ca82feea.webp",
        "width": 800,
        "height": 670
      },
      "poi_business_url": "https://www.chp.edu/?utm_source=google&utm_medium=organic&utm_campaign=business-profile&utm_content=hospital-swpa-upmc-childrens-hospital-of-pittsburgh",
      "poi_directions_map_url": "https://maps.google.com/?cid=10462800810672446527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upmc-childrens-hospital-of-pittsburgh",
      "poi_latitude": "40.4670523",
      "poi_longitude": "-79.9535322",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 412-692-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-497e-7399-a0dd-cb79991b5d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-497e-7399-a0dd-cb79991b5d64",
        "storage_key": "property/6767906449166965/019d026f-497e-7399-a0dd-cb79991b5d64.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJi5Ly2wFiNIgRP9zMK-dVM5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9304c412-97c3-4fce-a9a9-49f36d7ffbe3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "poi_name": "AHN Allegheny General Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "320 E North Ave Suite 0, Pittsburgh, PA 15212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91d-0597-710f-a109-eb03bee986c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91d-0597-710f-a109-eb03bee986c7",
        "storage_key": "property/6767906449166965/019fd91d-0597-710f-a109-eb03bee986c7.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "https://www.ahn.org/locations/hospitals/allegheny-general",
      "poi_directions_map_url": "https://maps.google.com/?cid=11434306477104869437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahn-allegheny-general-hospital",
      "poi_latitude": "40.4570277",
      "poi_longitude": "-80.0033309",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 412-359-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019d026f-497e-7399-a0dd-cb79991b5d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-497e-7399-a0dd-cb79991b5d64",
        "storage_key": "property/6767906449166965/019d026f-497e-7399-a0dd-cb79991b5d64.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJc3z20fDzNIgRPbDIzCjRrp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f87b726d-8f2a-4518-89bd-e51e93bb0100",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_cedf8a2a-055c-4105-8d01-30327d833b27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fdd39ae0-cb3d-4a33-bbf7-eb768ae13640",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b40ecd0b-289a-44d1-8a80-1aa5ceac9657",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c0b5239d-8202-48a8-96db-04dc32287adb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1e622145-fc56-4c99-9057-05a7c2c8bfb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2671bc85-c174-4347-b66b-ff159f419b3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "rating": "5.0",
      "name": "llostq",
      "text": "Love it just the fact that they don’t deal with packages being lost is a turn off other than that it is good",
      "date": "2025-11-01",
      "title": ""
    },
    {
      "id": "custom_9e5c6cbf-3160-4ba8-816d-fa89e5947f77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "rating": "5.0",
      "name": "cgaming 0197",
      "text": "Living here is awesome. Get to have your own small but convenient storage space if you don't have alot of space for things. This place is awesome to live in. And the land manager Adrianna, she is the most likable landlord that my fiancé and I ever had. She's very reasonable when it comes to certain things. I highly recommend this place if you are a first timer for getting your life in order for a small place when you don't want a huge place. And it's excellent with pets too. So I am so glad to have this place as a start for my life to begin and to get a house later on. Again, highly recommend this if you are just starting out to live on your own. More to follow. And the maintenence crews, Mark and Adam are the best people I have ever had when it comes to having something be fixed up when needed.",
      "date": "2023-04-16",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_96e3b5b7-2092-49a3-a129-330e1d1c4986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/019fd91b-ac06-73f3-9e8e-8b20eb025654.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91b-ac06-73f3-9e8e-8b20eb025654",
        "storage_key": "property/6767906449166965/019fd91b-ac06-73f3-9e8e-8b20eb025654.webp",
        "width": 1920,
        "height": 1282
      },
      "virtual_tour_title": "1869 West",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=63686ae3315fcf2628e9213b"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_ec8cfb07a689b86951a38e61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452718",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_92812dbbf8874d29e9c7d2c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452719",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_04c2d65f5c3cf4e3093e678e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452721",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0a729bbc8994939e6f62501b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452722",
      "name": "Pest Control",
      "description": "false",
      "amount": 3,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a0026867eebcf4247e7dabd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452723",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_88941b4fc1f7c1daba532e5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452724",
      "name": "Trash Service",
      "description": "false",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_26baf88ff063bde9e5e4d4a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452726",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ba1f72d4572baa0303c6870f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452727",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1f777ff75802c3969faea50f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "452729",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6a2c91984a5e1d7a94629987",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "514391",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 40,
      "amount_max": 70,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_42ec29f1b8d3c90a938219b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "543133",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a1c60ca9bc56c89b0e3180c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "543137",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9be69bbb0b840b38191606e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "835331",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_65a8b9b31f93866b8fb92b44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "838637",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Two Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_270840056668ba961390dfe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "838639",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_11bc87e118ec6c609f2ffc95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "838645",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a63c20f0485d2420a9842a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "engrain",
      "external_id": "885244",
      "name": "Parking - Unreserved",
      "description": "false",
      "amount": 10,
      "amount_max": 40,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019bc886-02d5-72fd-846e-ce8a767f132d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-1869-west",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965"
    },
    {
      "lead_collector_id": "019c3043-c9ef-733f-8c56-ac7a365b1111",
      "lead_source": "FACEBOOK_ADS",
      "name": "1869-west",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965"
    },
    {
      "lead_collector_id": "019c3043-ca5f-7068-b3c0-5f6707ec71ee",
      "lead_source": "LANDING_PAGE",
      "name": "1869-west",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-pittsburgh-pa-1869-west-505",
      "search_query": "pet friendly apartments Pittsburgh PA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Pittsburgh, PA",
      "h2_subtitle": "One, two and three bedroom apartments in Westwood with green courtyards and room for your pets",
      "page_copy": "Looking for pet-friendly apartments in Pittsburgh, PA? 1869 West welcomes pets in a quiet community in the Westwood neighborhood, between Crafton and Green Tree. Tree-lined lawns and walking paths between our brick buildings make daily walks easy, and Oakwood Park and Green Tree Park are both close by for longer outings.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. Residents enjoy on-site laundry facilities, extra storage space, on-site parking and a playground, plus on-site management and 24-hour emergency maintenance. Pay rent and submit maintenance requests online through the resident portal, and ask about short-term leases. Schedule a tour of our pet-friendly apartments in Pittsburgh today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7a-e03a-72fa-846c-6bae06a87142.webp",
      "featured_image_media": {
        "alt_text": "A sunny day at the multifamily property with brick buildings and lush green lawns.",
        "public_id": "01a13d7a-e03a-72fa-846c-6bae06a87142",
        "storage_key": "property/6767906449166965/01a13d7a-e03a-72fa-846c-6bae06a87142.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Pittsburgh, PA | 1869 West",
      "seo_description": "Pet-friendly apartments in Pittsburgh, PA at 1869 West in Westwood. 1, 2 and 3 bedroom homes with green courtyards and on-site parking. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "flexible-rent-payments-apartments-westwood-1869-west-820",
      "search_query": "apartments with flexible rent payments Westwood",
      "category": "Amenity",
      "h1_title": "Apartments with Flexible Rent Payments in Westwood",
      "h2_subtitle": "Online rent payments, a resident portal and short-term leases at affordable Westwood apartments",
      "page_copy": "1869 West offers apartments with flexible rent payments in Pittsburgh's Westwood neighborhood. Pay rent online through our resident portal whenever it suits you, and ask our leasing team about payment options and short-term leases that fit your budget and timeline.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. The community includes on-site laundry facilities, storage space, on-site parking and a playground, with on-site management and 24-hour emergency maintenance. Pets are welcome. From Westwood, Downtown Pittsburgh, Crafton and Green Tree are all a short drive away. Schedule a tour of 1869 West and ask about rent payment options today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7b-0fe9-755d-ab65-900b3da9222a.webp",
      "featured_image_media": {
        "alt_text": "1869 West Apartment Homes monument sign with phone number and website.",
        "public_id": "01a13d7b-0fe9-755d-ab65-900b3da9222a",
        "storage_key": "property/6767906449166965/01a13d7b-0fe9-755d-ab65-900b3da9222a.webp",
        "width": 1024,
        "height": 575
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flexible Rent Payment Apartments Westwood | 1869 West",
      "seo_description": "Apartments with flexible rent payments in Westwood, Pittsburgh. Pay online, short-term leases and 1, 2 and 3 bedroom homes at 1869 West. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "online-resident-portal-allegheny-county-1869-west-44",
      "search_query": "online resident portal in Allegheny County",
      "category": "Amenity",
      "h1_title": "Online Resident Portal Apartments in Allegheny County",
      "h2_subtitle": "Pay rent and request maintenance online at 1869 West in Pittsburgh's Westwood neighborhood",
      "page_copy": "At 1869 West, managing your apartment takes a few taps. Our online resident portal lets you pay rent, submit maintenance requests and keep track of your account from your phone or laptop, any time of day. It is one reason residents across Allegheny County choose our community in Pittsburgh's Westwood neighborhood.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. When something needs fixing, our on-site maintenance team responds to requests, and 24-hour emergency maintenance is always available. Residents also enjoy on-site laundry facilities, storage space, on-site parking, a playground and a pet-friendly community. Schedule a tour of 1869 West today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7b-3dd2-739a-b780-57ace75b9785.webp",
      "featured_image_media": {
        "alt_text": "A young woman smiles while looking at her phone in a hallway.",
        "public_id": "01a13d7b-3dd2-739a-b780-57ace75b9785",
        "storage_key": "property/6767906449166965/01a13d7b-3dd2-739a-b780-57ace75b9785.webp",
        "width": 1600,
        "height": 1065
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Online Resident Portal Apartments Allegheny Co. | 1869 West",
      "seo_description": "Apartments with an online resident portal in Allegheny County. Pay rent and request maintenance online at 1869 West in Westwood, Pittsburgh. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "playground-apartments-pittsburgh-pa-1869-west-660",
      "search_query": "apartments with playground Pittsburgh PA",
      "category": "Amenity",
      "h1_title": "Apartments with a Playground in Pittsburgh, PA",
      "h2_subtitle": "Family-friendly one, two and three bedroom apartments with an on-site playground in Westwood",
      "page_copy": "1869 West offers apartments with a playground in Pittsburgh, PA, right on site. Kids can climb and slide steps from home, while the open lawns between our brick buildings give everyone room to play. Our community sits in the Westwood neighborhood, with Oakwood Park and Green Tree Park close by for even more outdoor time.\n\nFamilies can choose a two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment, or a one bedroom (575 sq ft) for smaller households. Every home has large closets and a fully applianced kitchen, and select homes feature vinyl plank flooring. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make busy days easier. Pets are welcome. Schedule a tour of our apartments with a playground in Pittsburgh today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7b-71db-75a6-bf81-6dada6dc0fca.webp",
      "featured_image_media": {
        "alt_text": "Playground with slides and stairs.",
        "public_id": "01a13d7b-71db-75a6-bf81-6dada6dc0fca",
        "storage_key": "property/6767906449166965/01a13d7b-71db-75a6-bf81-6dada6dc0fca.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Playground Pittsburgh, PA | 1869 West",
      "seo_description": "Apartments with an on-site playground in Pittsburgh, PA. Family-friendly 1, 2 and 3 bedroom homes with green lawns at 1869 West in Westwood. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "24-hour-emergency-maintenance-apartments-15205-937",
      "search_query": "24-hour emergency maintenance apartments 15205",
      "category": "Amenity",
      "h1_title": "Apartments with 24-Hour Emergency Maintenance in 15205",
      "h2_subtitle": "On-site management, online maintenance requests and 24-hour emergency service in Westwood",
      "page_copy": "At 1869 West in Pittsburgh's 15205 zip, help is available around the clock. Our 24-hour emergency maintenance team handles urgent issues day or night, and for everything else you can submit a request online through the resident portal. Our on-site management team is here during office hours to answer questions in person.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. The community also offers on-site laundry facilities, storage space, on-site parking and a playground, and pets are welcome. Located in the Westwood neighborhood between Crafton and Green Tree, 1869 West keeps you close to Downtown Pittsburgh and the West End. Schedule a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7b-a77e-7385-a0dc-54fddf2504a4.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of brick apartment buildings surrounded by trees and greenery.",
        "public_id": "01a13d7b-a77e-7385-a0dc-54fddf2504a4",
        "storage_key": "property/6767906449166965/01a13d7b-a77e-7385-a0dc-54fddf2504a4.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Maintenance Apartments 15205 | 1869 West",
      "seo_description": "Apartments with 24-hour emergency maintenance in Pittsburgh 15205. Online maintenance requests and on-site management at 1869 West. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-pittsburgh-pa-1869-west-555",
      "search_query": "one bedroom apartments pittsburgh pa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Pittsburgh, PA",
      "h2_subtitle": "Affordable 575 sq ft one bedroom apartments in Pittsburgh's Westwood neighborhood",
      "page_copy": "1869 West offers one bedroom apartments in Pittsburgh, PA at a price that fits your budget. Our 575 sq ft layout includes a separate bedroom, a living area and a fully applianced kitchen, with large closets for everything you own. Select homes feature vinyl plank flooring and updated white or oak cabinets.\n\nOur community is in the Westwood neighborhood, between Crafton and Green Tree, with Downtown Pittsburgh a short drive away. Residents enjoy on-site laundry facilities, storage space, on-site parking and a playground, plus on-site management and 24-hour emergency maintenance. Pay rent and request maintenance online, and ask about short-term leases. Pets are welcome. Check availability on our one bedroom apartments and schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7b-d7e4-7119-aa32-b0765aeca615.webp",
      "featured_image_media": {
        "alt_text": "Cozy bedroom with a bed, dresser, chair, and windows.",
        "public_id": "01a13d7b-d7e4-7119-aa32-b0765aeca615",
        "storage_key": "property/6767906449166965/01a13d7b-d7e4-7119-aa32-b0765aeca615.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Pittsburgh, PA | 1869 West",
      "seo_description": "One bedroom apartments in Pittsburgh, PA at 1869 West. 575 sq ft homes with large closets and a fully applianced kitchen in Westwood. Check availability.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-westwood-pittsburgh-1869-west-724",
      "search_query": "two bedroom apartments westwood pittsburgh",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Westwood, Pittsburgh",
      "h2_subtitle": "Two bedroom apartments from 625 to 675 sq ft in Westwood, between Crafton and Green Tree",
      "page_copy": "1869 West offers two bedroom apartments in Westwood, Pittsburgh in two layouts, 625 and 675 sq ft. The second bedroom works for a roommate, a child, a guest room or a home office, and large closets keep everything organized. Each home includes a fully applianced kitchen, and select homes feature vinyl plank flooring and updated cabinets.\n\nOutside, tree-lined lawns, a playground and on-site parking make 1869 West feel like a neighborhood. Residents also have on-site laundry facilities, storage space, on-site management and 24-hour emergency maintenance, with rent payments and maintenance requests handled online. Pets are welcome. Westwood puts you between Crafton and Green Tree, with Downtown Pittsburgh a short drive away. Check availability on our two bedroom apartments and schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7c-1226-7449-82f1-bbc02264c41a.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with gray sofa, coffee table, and wooden furniture.",
        "public_id": "01a13d7c-1226-7449-82f1-bbc02264c41a",
        "storage_key": "property/6767906449166965/01a13d7c-1226-7449-82f1-bbc02264c41a.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Westwood Pittsburgh | 1869 West",
      "seo_description": "Two bedroom apartments in Westwood, Pittsburgh at 1869 West. 625 and 675 sq ft layouts with large closets and on-site laundry. Check availability today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-allegheny-county-1869-west-654",
      "search_query": "three bedroom apartments allegheny county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Allegheny County",
      "h2_subtitle": "Affordable 725 sq ft three bedroom apartments for families and roommates in Westwood, Pittsburgh",
      "page_copy": "Three bedroom apartments can be hard to find in Allegheny County, especially at an affordable price. At 1869 West, our 725 sq ft three bedroom layout gives families and roommates a bedroom each, with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets.\n\nFamilies appreciate the on-site playground and the green lawns between buildings, and everyone appreciates on-site laundry facilities, extra storage space and on-site parking. On-site management and 24-hour emergency maintenance keep things running, and rent and maintenance requests are handled online. Pets are welcome. Our Westwood location sits between Crafton and Green Tree, close to parks, schools and Downtown Pittsburgh. Schedule a tour of our three bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7c-4336-76ac-b9f0-491e21afae30.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a blue armchair and a table with chairs.",
        "public_id": "01a13d7c-4336-76ac-b9f0-491e21afae30",
        "storage_key": "property/6767906449166965/01a13d7c-4336-76ac-b9f0-491e21afae30.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Allegheny County | 1869 West",
      "seo_description": "Three bedroom apartments in Allegheny County at 1869 West. 725 sq ft homes with a playground and on-site laundry in Westwood, Pittsburgh. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-near-westwood-elementary-school-pa-1869-west-575",
      "search_query": "apartments near Westwood Elementary School PA",
      "category": "School",
      "h1_title": "Apartments Near Westwood Elementary School in Pittsburgh",
      "h2_subtitle": "Family-friendly apartments in Westwood, a short walk from Pittsburgh Westwood K-5",
      "page_copy": "1869 West is a short walk from Pittsburgh Westwood K-5, the neighborhood elementary school in Westwood. For families, that means an easy morning routine and a school community right around the corner. Check with Pittsburgh Public Schools to confirm school assignments for your address.\n\nOur two bedroom (625 or 675 sq ft) and three bedroom (725 sq ft) apartments give kids room to grow, with large closets and fully applianced kitchens. One bedroom homes are also available. Back home, the on-site playground and green lawns are perfect for after-school play. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make family life easier, and pets are welcome. Schedule a tour of our apartments near Westwood Elementary School today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7c-70e6-77fd-8639-0a735d13c807.webp",
      "featured_image_media": {
        "alt_text": "A smiling young boy wearing a backpack and a checkered shirt",
        "public_id": "01a13d7c-70e6-77fd-8639-0a735d13c807",
        "storage_key": "property/6767906449166965/01a13d7c-70e6-77fd-8639-0a735d13c807.webp",
        "width": 1600,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westwood Elementary School | 1869 West",
      "seo_description": "Apartments near Westwood Elementary School in Pittsburgh. Family-friendly 2 and 3 bedroom homes with a playground at 1869 West. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-close-to-pittsburgh-classical-academy-1869-west-374",
      "search_query": "apartments close to Pittsburgh Classical Academy Pittsburgh",
      "category": "School",
      "h1_title": "Apartments Near Pittsburgh Classical Academy",
      "h2_subtitle": "Westwood apartments a short drive from Pittsburgh Classical Academy in Crafton Heights",
      "page_copy": "1869 West offers apartments a short drive from Pittsburgh Classical Academy, the Pittsburgh Public Schools middle school in nearby Crafton Heights. Our Westwood community is a convenient home base for families and school staff on the city's West End. Check with Pittsburgh Public Schools for enrollment details.\n\nChoose a two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen, or a one bedroom if you need less space. Select homes feature vinyl plank flooring. The community includes an on-site playground, on-site laundry facilities, storage space and on-site parking, with on-site management and 24-hour emergency maintenance. Pets are welcome. Schedule a tour of our apartments near Pittsburgh Classical Academy today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7c-9f06-7670-8ee7-c54ecc91470a.webp",
      "featured_image_media": {
        "alt_text": "Students in a classroom setting, some writing, one standing with books and a backpack.",
        "public_id": "01a13d7c-9f06-7670-8ee7-c54ecc91470a",
        "storage_key": "property/6767906449166965/01a13d7c-9f06-7670-8ee7-c54ecc91470a.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittsburgh Classical Academy | 1869 West",
      "seo_description": "Apartments near Pittsburgh Classical Academy in Crafton Heights. Family-friendly 2 and 3 bedroom homes with a playground at 1869 West. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-by-pittsburgh-carmalt-prek-8-allegheny-county-1869-west-886",
      "search_query": "apartments by Pittsburgh Carmalt PreK-8 Allegheny County",
      "category": "School",
      "h1_title": "Apartments Near Pittsburgh Carmalt PreK-8",
      "h2_subtitle": "Family-friendly Westwood apartments a short drive from Pittsburgh Carmalt PreK-8 in the South Hills",
      "page_copy": "Families with students at Pittsburgh Carmalt PreK-8 can find an affordable home at 1869 West, a short drive from the school's campus in the city's South Hills. Our Westwood community gives you quick access to Carmalt and the rest of Allegheny County. Check with Pittsburgh Public Schools for enrollment and transportation details.\n\nOur two bedroom (625 or 675 sq ft) and three bedroom (725 sq ft) apartments have large closets and fully applianced kitchens, and select homes feature vinyl plank flooring. Kids can burn off energy at the on-site playground, while parents appreciate on-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance. Pets are welcome, and short-term leases are available. Schedule a tour of our apartments near Pittsburgh Carmalt PreK-8 today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7d-3c6c-739b-bc52-92a82d25589c.webp",
      "featured_image_media": {
        "alt_text": "A young girl with a backpack smiles at the camera while walking outdoors.",
        "public_id": "01a13d7d-3c6c-739b-bc52-92a82d25589c",
        "storage_key": "property/6767906449166965/01a13d7d-3c6c-739b-bc52-92a82d25589c.webp",
        "width": 1600,
        "height": 883
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittsburgh Carmalt PreK-8 | 1869 West",
      "seo_description": "Apartments near Pittsburgh Carmalt PreK-8 in Allegheny County. 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartment-rentals-near-beechwood-elementary-school-15205-1869-west-609",
      "search_query": "apartment rentals near Beechwood Elementary School 15205",
      "category": "School",
      "h1_title": "Apartment Rentals Near Beechwood Elementary School",
      "h2_subtitle": "Family-friendly 15205 rentals in Westwood, a short drive from Pittsburgh Beechwood in Beechview",
      "page_copy": "1869 West offers apartment rentals in the 15205 zip, a short drive from Pittsburgh Beechwood, the elementary school in neighboring Beechview. Our Westwood community is a convenient, affordable home for families and school staff on the south and west sides of the city. Check with Pittsburgh Public Schools for enrollment details.\n\nOur two bedroom (625 or 675 sq ft) and three bedroom (725 sq ft) rentals have large closets and fully applianced kitchens, and select homes feature vinyl plank flooring. The on-site playground and green lawns give kids room to play, and on-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make day-to-day life simpler. Pets are welcome. Schedule a tour of our rentals near Beechwood Elementary School today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d8a-3bd5-7265-9052-11ba0b8c9a66.webp",
      "featured_image_media": {
        "alt_text": "Children in backpacks walking",
        "public_id": "01a13d8a-3bd5-7265-9052-11ba0b8c9a66",
        "storage_key": "property/6767906449166965/01a13d8a-3bd5-7265-9052-11ba0b8c9a66.webp",
        "width": 1600,
        "height": 1250
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Beechwood Elementary School | 1869 West",
      "seo_description": "Apartment rentals near Beechwood Elementary School in Beechview. 2 and 3 bedroom homes with a playground at 1869 West in 15205. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-near-brashear-high-school-pittsburgh-1869-west-415",
      "search_query": "apartments near Brashear High School Pittsburgh",
      "category": "School",
      "h1_title": "Apartments Near Brashear High School in Pittsburgh",
      "h2_subtitle": "Two and three bedroom Westwood apartments a short drive from Brashear High School in Beechview",
      "page_copy": "1869 West offers apartments a short drive from Brashear High School, the Pittsburgh Public Schools high school on Crane Avenue in Beechview. For families with teens, our Westwood community offers more space and an easy trip to school. Check with Pittsburgh Public Schools for enrollment and transportation details.\n\nOur three bedroom (725 sq ft) apartments give everyone a room of their own, and our two bedroom (625 or 675 sq ft) layouts work well for smaller families. Each home has large closets and a fully applianced kitchen, and select homes feature vinyl plank flooring. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance keep life simple, and rent can be paid online. Pets are welcome. Schedule a tour of our apartments near Brashear High School today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7d-9a2a-73fc-a5a4-514d276deac3.webp",
      "featured_image_media": {
        "alt_text": "A group of five young adults walking down a city sidewalk.",
        "public_id": "01a13d7d-9a2a-73fc-a5a4-514d276deac3",
        "storage_key": "property/6767906449166965/01a13d7d-9a2a-73fc-a5a4-514d276deac3.webp",
        "width": 1600,
        "height": 898
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brashear High School | 1869 West",
      "seo_description": "Apartments near Brashear High School in Pittsburgh. Affordable 2 and 3 bedroom homes with on-site laundry at 1869 West in Westwood. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-around-south-hills-middle-school-westwood-1869-west-611",
      "search_query": "apartments around South Hills Middle School Westwood",
      "category": "School",
      "h1_title": "Apartments Near South Hills Middle School",
      "h2_subtitle": "Westwood apartments a short drive from Pittsburgh South Hills 6-8 in Beechview",
      "page_copy": "1869 West in Westwood is a short drive from Pittsburgh South Hills 6-8, the middle school on Crane Avenue in Beechview. Families get an affordable home with room to grow and an easy commute to school. Check with Pittsburgh Public Schools for enrollment and transportation details.\n\nChoose a two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated cabinets. The on-site playground and open lawns give younger siblings space to play, and on-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make family life easier. Pets are welcome. Schedule a tour of our apartments near South Hills Middle School today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d7f-593d-76d5-a899-0929df624ba2.webp",
      "featured_image_media": {
        "alt_text": "Teacher instructing students in a classroom",
        "public_id": "01a13d7f-593d-76d5-a899-0929df624ba2",
        "storage_key": "property/6767906449166965/01a13d7f-593d-76d5-a899-0929df624ba2.webp",
        "width": 1600,
        "height": 996
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Hills Middle School | 1869 West",
      "seo_description": "Apartments near South Hills Middle School in Pittsburgh. 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "rentals-close-crafton-elementary-school-pittsburgh-1869-west-630",
      "search_query": "rentals close Crafton Elementary School Pittsburgh",
      "category": "School",
      "h1_title": "Rentals Near Crafton Elementary School",
      "h2_subtitle": "Westwood rentals less than a mile from Crafton Elementary School in the borough of Crafton",
      "page_copy": "1869 West sits just over the line from the borough of Crafton, less than a mile from Crafton Elementary School. Our Westwood rentals give school staff and families easy access to Crafton's schools, shops and parks. Crafton Elementary is part of the Carlynton School District, so check with the district about enrollment for your address.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. The on-site playground, green lawns, on-site laundry facilities, storage space and on-site parking make day-to-day life easy, with on-site management and 24-hour emergency maintenance when you need it. Pets are welcome. Schedule a tour of our rentals near Crafton Elementary School today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d81-7c99-75ab-80ae-0f85727584f9.webp",
      "featured_image_media": {
        "alt_text": "Exterior of Crafton Elementary School building",
        "public_id": "01a13d81-7c99-75ab-80ae-0f85727584f9",
        "storage_key": "property/6767906449166965/01a13d81-7c99-75ab-80ae-0f85727584f9.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Crafton Elementary School | 1869 West",
      "seo_description": "Rentals near Crafton Elementary School in Crafton, PA. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-nearby-pittsburgh-brookline-prek-8-school-pa-1869-west-65",
      "search_query": "apartments nearby Pittsburgh Brookline PreK-8 School PA",
      "category": "School",
      "h1_title": "Apartments Near Pittsburgh Brookline PreK-8",
      "h2_subtitle": "Family-friendly Westwood apartments a short drive from Pittsburgh Brookline PreK-8",
      "page_copy": "Families with students at Pittsburgh Brookline PreK-8 can find an affordable home at 1869 West, a short drive from Brookline in the city's South Hills. Our Westwood community offers family-friendly space and quick access to Brookline Boulevard's shops and restaurants. Check with Pittsburgh Public Schools for enrollment and transportation details.\n\nOur two bedroom (625 or 675 sq ft) and three bedroom (725 sq ft) apartments include large closets and fully applianced kitchens, and select homes feature vinyl plank flooring. Kids have an on-site playground and green lawns for after-school play. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make busy weeks easier. Pets are welcome. Schedule a tour of our apartments near Pittsburgh Brookline PreK-8 today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d81-b0c5-726e-8c92-9f2c09f46b66.webp",
      "featured_image_media": {
        "alt_text": "Street view with traffic lights, buildings, and cars.",
        "public_id": "01a13d81-b0c5-726e-8c92-9f2c09f46b66",
        "storage_key": "property/6767906449166965/01a13d81-b0c5-726e-8c92-9f2c09f46b66.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittsburgh Brookline PreK-8 | 1869 West",
      "seo_description": "Apartments near Pittsburgh Brookline PreK-8. Family-friendly 2 and 3 bedroom homes with a playground at 1869 West in Westwood, Pittsburgh. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-near-ccac-allegheny-campus-pittsburgh-1869-west-830",
      "search_query": "apartments near CCAC Allegheny Campus Pittsburgh",
      "category": "School",
      "h1_title": "Apartments Near CCAC Allegheny Campus in Pittsburgh",
      "h2_subtitle": "Affordable Westwood apartments a short drive from CCAC's Allegheny Campus on the North Side",
      "page_copy": "1869 West offers affordable apartments a short drive from the Community College of Allegheny County's Allegheny Campus on Pittsburgh's North Side. Students, faculty and staff can live in a quiet Westwood neighborhood and still reach campus quickly.\n\nA one bedroom (575 sq ft) is ideal for living solo, and two bedroom (625 or 675 sq ft) and three bedroom (725 sq ft) layouts make splitting rent with roommates easy. Every home has large closets and a fully applianced kitchen. Short-term leases are available, and you can pay rent and request maintenance online. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance round it out. Pets are welcome. Schedule a tour of our apartments near CCAC Allegheny Campus today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d81-e3ed-75ab-8613-591f99fb8ab5.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with brick and concrete architecture and large glass windows.",
        "public_id": "01a13d81-e3ed-75ab-8613-591f99fb8ab5",
        "storage_key": "property/6767906449166965/01a13d81-e3ed-75ab-8613-591f99fb8ab5.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near CCAC Allegheny Campus | 1869 West",
      "seo_description": "Apartments near CCAC Allegheny Campus in Pittsburgh. Affordable 1, 2 and 3 bedroom homes with short-term leases at 1869 West in Westwood. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "student-housing-near-point-park-university-pittsburgh-1869-west-47",
      "search_query": "student housing near Point Park University Pittsburgh",
      "category": "School",
      "h1_title": "Apartments for Point Park University Students",
      "h2_subtitle": "Affordable Westwood apartments a short drive from Downtown Pittsburgh and Point Park University",
      "page_copy": "Looking for student housing near Point Park University without Downtown rent? 1869 West is in Pittsburgh's Westwood neighborhood, a short drive from Downtown and Point Park's campus. Our affordable apartments give students more space and a quieter place to study.\n\nSplit a two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with roommates, or take a one bedroom (575 sq ft) for yourself. Every home has large closets and a fully applianced kitchen. Short-term leases are available to fit the academic year, and rent and maintenance requests are handled online. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make student life simpler. Pets are welcome. Schedule a tour of 1869 West today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d82-1884-70df-854c-831a6d5ccf3c.webp",
      "featured_image_media": {
        "alt_text": "Pittsburgh skyline with UPMC and K&L Gates buildings prominent.",
        "public_id": "01a13d82-1884-70df-854c-831a6d5ccf3c",
        "storage_key": "property/6767906449166965/01a13d82-1884-70df-854c-831a6d5ccf3c.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Point Park University | 1869 West",
      "seo_description": "Affordable apartments for Point Park University students in Westwood, a short drive from Downtown Pittsburgh. Short-term leases at 1869 West. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-near-st-clair-hospital-pittsburgh-1869-west-483",
      "search_query": "apartments near St. Clair Hospital Pittsburgh",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Clair Hospital in Pittsburgh",
      "h2_subtitle": "Affordable Westwood apartments a short drive from St. Clair Hospital in Mt. Lebanon",
      "page_copy": "1869 West offers affordable apartments a short drive from St. Clair Hospital in Mt. Lebanon. For nurses, techs and healthcare staff, our Westwood community offers a quiet place to rest between shifts and a quick commute through the South Hills.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. On-site parking makes coming and going at odd hours simple, and on-site laundry facilities make it easy to keep scrubs clean. 24-hour emergency maintenance, on-site management and online rent payments and maintenance requests fit busy schedules, and short-term leases are available for travel staff. Pets are welcome. Schedule a tour of our apartments near St. Clair Hospital today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d82-492c-73df-b15a-d47de2c089a0.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a large tan building with multiple levels and many windows, surrounded by trees and a parking lot.",
        "public_id": "01a13d82-492c-73df-b15a-d47de2c089a0",
        "storage_key": "property/6767906449166965/01a13d82-492c-73df-b15a-d47de2c089a0.webp",
        "width": 1600,
        "height": 858
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Clair Hospital Pittsburgh | 1869 West",
      "seo_description": "Apartments near St. Clair Hospital for nurses and healthcare staff. Affordable 1, 2 and 3 bedroom homes with on-site parking at 1869 West. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-near-pittsburgh-botanic-garden-1869-west-388",
      "search_query": "apartments near Pittsburgh Botanic Garden",
      "category": "Park",
      "h1_title": "Apartments Near Pittsburgh Botanic Garden",
      "h2_subtitle": "Westwood apartments a short drive east of Pittsburgh Botanic Garden's gardens and woodland trails",
      "page_copy": "1869 West offers apartments a short drive from Pittsburgh Botanic Garden in North Fayette, where themed gardens, woodland trails and seasonal events make an easy weekend escape. Head west from our Westwood neighborhood and you will be among the flowers in no time.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. At home, tree-lined lawns and walking paths between buildings bring a little green to every day. Residents also enjoy an on-site playground, laundry facilities, storage space and on-site parking, with on-site management and 24-hour emergency maintenance. Pets are welcome. Schedule a tour of our apartments near Pittsburgh Botanic Garden today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d84-e42f-712d-946f-16521e9d9e26.webp",
      "featured_image_media": {
        "alt_text": "Stone pathway winding through a vibrant garden with colorful flowers, lush greenery, and a wooden bench.",
        "public_id": "01a13d84-e42f-712d-946f-16521e9d9e26",
        "storage_key": "property/6767906449166965/01a13d84-e42f-712d-946f-16521e9d9e26.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittsburgh Botanic Garden | 1869 West",
      "seo_description": "Apartments near Pittsburgh Botanic Garden. Affordable 1, 2 and 3 bedroom homes in Westwood, Pittsburgh with green lawns at 1869 West. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-close-to-settlers-cabin-park-pa-1869-west-305",
      "search_query": "apartments close to Settlers Cabin Park PA",
      "category": "Park",
      "h1_title": "Apartments Near Settlers Cabin Park",
      "h2_subtitle": "Westwood apartments a short drive from Settlers Cabin Park's trails, picnic groves and wave pool",
      "page_copy": "Outdoor lovers can find an affordable home at 1869 West, a short drive from Settlers Cabin Park. The Allegheny County park offers hiking and biking trails, picnic groves and a summer wave pool, all within easy reach of our Westwood neighborhood via the Parkway West.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. Store your outdoor gear in our available storage space, and enjoy an on-site playground, green lawns, laundry facilities and on-site parking. On-site management and 24-hour emergency maintenance keep things running, and pets are welcome. Schedule a tour of our apartments near Settlers Cabin Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d85-8c6b-755f-8f53-769e91a4b851.webp",
      "featured_image_media": {
        "alt_text": "Couple hiking near a waterfall.",
        "public_id": "01a13d85-8c6b-755f-8f53-769e91a4b851",
        "storage_key": "property/6767906449166965/01a13d85-8c6b-755f-8f53-769e91a4b851.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Settlers Cabin Park, PA | 1869 West",
      "seo_description": "Apartments near Settlers Cabin Park in Allegheny County. Affordable 1, 2 and 3 bedroom homes at 1869 West in Westwood, Pittsburgh. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "rentals-by-green-tree-park-pittsburgh-1869-west-356",
      "search_query": "rentals by Green Tree Park Pittsburgh",
      "category": "Park",
      "h1_title": "Rentals Near Green Tree Park in Pittsburgh",
      "h2_subtitle": "Affordable Westwood rentals less than a mile from Green Tree Park",
      "page_copy": "1869 West offers rentals less than a mile from Green Tree Park, the community park in the neighboring borough of Green Tree. Head over for a walk, a game or a picnic, then come home to our quiet Westwood neighborhood.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. Our community has its own on-site playground and tree-lined lawns, plus laundry facilities, storage space and on-site parking. On-site management and 24-hour emergency maintenance are here when you need them, and rent and maintenance requests are handled online. Pets are welcome. Schedule a tour of our rentals near Green Tree Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d85-bf65-734f-81ce-41a760e7ade4.webp",
      "featured_image_media": {
        "alt_text": "Father and daughter holding hands and smiling in a grassy outdoor area.",
        "public_id": "01a13d85-bf65-734f-81ce-41a760e7ade4",
        "storage_key": "property/6767906449166965/01a13d85-bf65-734f-81ce-41a760e7ade4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Green Tree Park Pittsburgh | 1869 West",
      "seo_description": "Rentals near Green Tree Park in Pittsburgh. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "living-near-oakwood-park-westwood-1869-west-389",
      "search_query": "living near Oakwood Park Westwood",
      "category": "Park",
      "h1_title": "Apartments Near Oakwood Park in Westwood",
      "h2_subtitle": "Affordable apartments about half a mile from Oakwood Park on Pittsburgh's West End",
      "page_copy": "1869 West in Westwood is about half a mile from Oakwood Park, a neighborhood park for walks, picnics and time outdoors. It is an easy outing from home, whether you are taking the dog out or getting the kids out of the house.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. The community has its own on-site playground and green lawns, plus laundry facilities, storage space and on-site parking. On-site management and 24-hour emergency maintenance are here for you, and pets are welcome. Schedule a tour of our apartments near Oakwood Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d88-db89-705f-a624-fe8bfcf1d0e6.webp",
      "featured_image_media": {
        "alt_text": "Family with two young children enjoying an autumn day outdoors.",
        "public_id": "01a13d88-db89-705f-a624-fe8bfcf1d0e6",
        "storage_key": "property/6767906449166965/01a13d88-db89-705f-a624-fe8bfcf1d0e6.webp",
        "width": 1600,
        "height": 1101
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oakwood Park Westwood | 1869 West",
      "seo_description": "Apartments near Oakwood Park in Westwood, Pittsburgh. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "find-apartments-around-crafton-park-15205-1869-west-396",
      "search_query": "find apartments around Crafton Park 15205",
      "category": "Park",
      "h1_title": "Apartments Near Crafton Park in 15205",
      "h2_subtitle": "Affordable Westwood apartments about a mile from Crafton Park in the 15205 zip",
      "page_copy": "Looking for apartments around Crafton Park in 15205? 1869 West is about a mile from the park in the borough of Crafton, a good spot for a game, a walk or a picnic. Our Westwood community shares the 15205 zip and puts you close to Crafton's shops and restaurants.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. On-site amenities include a playground, tree-lined lawns, laundry facilities, storage space and on-site parking. On-site management and 24-hour emergency maintenance are always available, and rent and maintenance requests are handled online. Pets are welcome. Schedule a tour of our apartments near Crafton Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d86-2289-76cc-a746-0e39eb83dfcd.webp",
      "featured_image_media": {
        "alt_text": "A family having a picnic on a blanket in the park, with a '3' balloon.",
        "public_id": "01a13d86-2289-76cc-a746-0e39eb83dfcd",
        "storage_key": "property/6767906449166965/01a13d86-2289-76cc-a746-0e39eb83dfcd.webp",
        "width": 1600,
        "height": 951
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Crafton Park 15205 | 1869 West",
      "seo_description": "Apartments near Crafton Park in 15205. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood, Pittsburgh. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "nearby-dunbar-park-apartments-allegheny-county-1869-west-530",
      "search_query": "nearby Dunbar Park apartments Allegheny County",
      "category": "Park",
      "h1_title": "Apartments Near Dunbar Park in Allegheny County",
      "h2_subtitle": "Affordable Westwood apartments less than a mile from Dunbar Park",
      "page_copy": "1869 West is less than a mile from Dunbar Park, a neighborhood green space close to our Westwood community. It is an easy spot for a walk, a game of catch or some fresh air close to home.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. Our community has its own on-site playground and green lawns, plus laundry facilities, storage space and on-site parking. On-site management and 24-hour emergency maintenance keep things running, and pets are welcome. Schedule a tour of our apartments near Dunbar Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d89-0f82-7363-9cf6-ebcc22847335.webp",
      "featured_image_media": {
        "alt_text": "Two women enjoying a picnic in a park on a sunny day, sharing pizza and drinks.",
        "public_id": "01a13d89-0f82-7363-9cf6-ebcc22847335",
        "storage_key": "property/6767906449166965/01a13d89-0f82-7363-9cf6-ebcc22847335.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Dunbar Park | 1869 West",
      "seo_description": "Apartments near Dunbar Park in Allegheny County. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "chartiers-playground-nearby-apartments-1869-west-472",
      "search_query": "Chartiers Playground nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Chartiers Playground",
      "h2_subtitle": "Family-friendly Westwood apartments near the parks and playgrounds of Pittsburgh's West End",
      "page_copy": "1869 West offers family-friendly apartments in Westwood, a short drive from Chartiers Playground and the other parks and playgrounds of Pittsburgh's West End. Spend a Saturday at the playground, then head home to a quiet neighborhood between Crafton and Green Tree.\n\nOur two bedroom (625 or 675 sq ft) and three bedroom (725 sq ft) apartments give families room to grow, and one bedrooms are available too. Every home has large closets and a fully applianced kitchen. You will not always need to leave home to play: 1869 West has its own on-site playground and green lawns. On-site laundry facilities, storage space, on-site parking and 24-hour emergency maintenance make life easier. Pets are welcome. Schedule a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d86-85b7-7258-b638-96fff6858ce4.webp",
      "featured_image_media": {
        "alt_text": "Three smiling children posing in front of a playground.",
        "public_id": "01a13d86-85b7-7258-b638-96fff6858ce4",
        "storage_key": "property/6767906449166965/01a13d86-85b7-7258-b638-96fff6858ce4.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chartiers Playground | 1869 West",
      "seo_description": "Apartments near Chartiers Playground on Pittsburgh's West End. Family-friendly 2 and 3 bedroom homes with an on-site playground at 1869 West. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-close-to-fairywood-park-pittsburgh-1869-west-60",
      "search_query": "apartments close to Fairywood Park Pittsburgh",
      "category": "Park",
      "h1_title": "Apartments Near Fairywood Park in Pittsburgh",
      "h2_subtitle": "Affordable Westwood apartments a short drive from Fairywood and Pittsburgh's West End parks",
      "page_copy": "1869 West offers affordable apartments in Westwood, a short drive from Fairywood Park and the neighboring Fairywood community on Pittsburgh's West End. Enjoy green space close to home and quick access to Crafton, Green Tree and Downtown.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. At home, residents enjoy an on-site playground, tree-lined lawns, laundry facilities, storage space and on-site parking. On-site management and 24-hour emergency maintenance are here when you need them, and rent and maintenance requests are handled online. Pets are welcome. Schedule a tour of our apartments near Fairywood Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d89-4521-75ac-8588-0e6c8ce55c09.webp",
      "featured_image_media": {
        "alt_text": "Mother and daughter holding hands walking on a path covered in autumn leaves.",
        "public_id": "01a13d89-4521-75ac-8588-0e6c8ce55c09",
        "storage_key": "property/6767906449166965/01a13d89-4521-75ac-8588-0e6c8ce55c09.webp",
        "width": 1600,
        "height": 1200
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fairywood Park Pittsburgh | 1869 West",
      "seo_description": "Apartments near Fairywood Park in Pittsburgh. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "sheraden-park-adjacent-rentals-westwood-1869-west-598",
      "search_query": "Sheraden Park adjacent rentals Westwood",
      "category": "Park",
      "h1_title": "Rentals Near Sheraden Park in Pittsburgh",
      "h2_subtitle": "Affordable Westwood rentals a short drive from Sheraden Park's trails and ballfields",
      "page_copy": "1869 West offers rentals a short drive from Sheraden Park, one of the larger city parks on Pittsburgh's West End, with wooded trails, ballfields and open space. Our Westwood community makes it easy to get there for a hike, a game or a walk with the dog.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. Our community also has its own on-site playground and green lawns, plus laundry facilities, storage space and on-site parking. On-site management and 24-hour emergency maintenance are always available, and pets are welcome. Schedule a tour of our rentals near Sheraden Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d89-7656-726d-be1c-70b25976638d.webp",
      "featured_image_media": {
        "alt_text": "Family walking on a wooden bridge in a natural setting.",
        "public_id": "01a13d89-7656-726d-be1c-70b25976638d",
        "storage_key": "property/6767906449166965/01a13d89-7656-726d-be1c-70b25976638d.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Sheraden Park Pittsburgh | 1869 West",
      "seo_description": "Rentals near Sheraden Park in Pittsburgh. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "mcgonigle-park-area-apartments-pittsburgh-1869-west-759",
      "search_query": "McGonigle Park area apartments PA",
      "category": "Park",
      "h1_title": "Apartments Near McGonigle Park in Pittsburgh",
      "h2_subtitle": "Affordable Westwood apartments near McGonigle Park and the green spaces of Pittsburgh's West End",
      "page_copy": "1869 West offers affordable apartments within easy reach of McGonigle Park and the many neighborhood parks around Pittsburgh's West End. Our Westwood community, between Crafton and Green Tree, makes it easy to get outside close to home.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. Residents enjoy an on-site playground, tree-lined lawns, laundry facilities, storage space and on-site parking, with on-site management and 24-hour emergency maintenance. Rent payments and maintenance requests are handled online, and pets are welcome. Schedule a tour of our apartments near McGonigle Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d87-4c6d-778d-8b51-4e8c0fac5366.webp",
      "featured_image_media": {
        "alt_text": "A family having a picnic in a park on a sunny day.",
        "public_id": "01a13d87-4c6d-778d-8b51-4e8c0fac5366",
        "storage_key": "property/6767906449166965/01a13d87-4c6d-778d-8b51-4e8c0fac5366.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McGonigle Park | 1869 West",
      "seo_description": "Apartments near McGonigle Park in Pittsburgh, PA. Affordable 1, 2 and 3 bedroom homes with a playground at 1869 West in Westwood. Schedule a tour.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartments-near-pittsburgh-international-airport-1869-west-871",
      "search_query": "apartments near pittsburgh international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Pittsburgh International Airport",
      "h2_subtitle": "Affordable Westwood apartments with an easy drive to Pittsburgh International Airport via the Parkway West",
      "page_copy": "1869 West is a convenient home base for frequent flyers and airport employees. From our Westwood neighborhood, Pittsburgh International Airport is an easy drive out the Parkway West (I-376), and Downtown Pittsburgh is a short drive in the other direction.\n\nChoose a one bedroom (575 sq ft), two bedroom (625 or 675 sq ft) or three bedroom (725 sq ft) apartment with large closets and a fully applianced kitchen. Select homes feature vinyl plank flooring and updated white or oak cabinets. On-site parking, storage space for luggage and gear, and online rent payments make life on the go easier. Short-term leases are available, and on-site management and 24-hour emergency maintenance look after things while you travel. Residents also enjoy on-site laundry facilities and a playground, and pets are welcome. Schedule a tour of our apartments near Pittsburgh International Airport today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d87-7d1c-712e-939b-c3c87c0b0254.webp",
      "featured_image_media": {
        "alt_text": "Interior view of a spacious, modern airport terminal with a distinctive red-trussed arched ceiling.",
        "public_id": "01a13d87-7d1c-712e-939b-c3c87c0b0254",
        "storage_key": "property/6767906449166965/01a13d87-7d1c-712e-939b-c3c87c0b0254.webp",
        "width": 1600,
        "height": 1044
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittsburgh Airport | 1869 West",
      "seo_description": "Apartments near Pittsburgh International Airport. Affordable 1, 2 and 3 bedroom homes with short-term leases at 1869 West in Westwood. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-en-pittsburgh-pa-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos en Pittsburgh, PA",
      "h2_subtitle": "Apartamentos de 1, 2 y 3 habitaciones en Westwood, entre Crafton y Green Tree",
      "page_copy": "¿Busca apartamentos en Pittsburgh, PA? 1869 West está en el vecindario de Westwood, entre Crafton y Green Tree, en el código postal 15205. Es una comunidad tranquila con jardines y árboles, a poca distancia en carro del centro de Pittsburgh.\n\nElija un apartamento de una habitación (575 pies cuadrados), de dos habitaciones (625 o 675 pies cuadrados) o de tres habitaciones (725 pies cuadrados), con closets amplios y cocina equipada con electrodomésticos. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados. La comunidad ofrece lavandería, espacio de almacenamiento, estacionamiento y un área de juegos para niños. Contamos con administración en el lugar y mantenimiento de emergencia las 24 horas. Puede pagar la renta y pedir reparaciones en línea. Se aceptan mascotas. Programe una visita a 1869 West hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d94-6b29-70ca-b072-4a4c6e3effc3.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with green lawn and trees.",
        "public_id": "01a13d94-6b29-70ca-b072-4a4c6e3effc3",
        "storage_key": "property/6767906449166965/01a13d94-6b29-70ca-b072-4a4c6e3effc3.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos en Pittsburgh, PA | 1869 West",
      "seo_description": "Apartamentos en Pittsburgh, PA en 1869 West. Unidades de 1, 2 y 3 habitaciones con estacionamiento, lavandería y área de juegos. Programe una visita hoy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-que-aceptan-mascotas-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos que Aceptan Mascotas en Pittsburgh",
      "h2_subtitle": "Apartamentos de 1, 2 y 3 habitaciones en Westwood con jardines y espacio para sus mascotas",
      "page_copy": "En 1869 West, su mascota también es bienvenida. Nuestra comunidad en Westwood, Pittsburgh, tiene jardines con árboles y caminos entre los edificios, ideales para pasear al perro todos los días. Oakwood Park y Green Tree Park quedan cerca para paseos más largos.\n\nElija un apartamento de una habitación (575 pies cuadrados), de dos habitaciones (625 o 675 pies cuadrados) o de tres habitaciones (725 pies cuadrados), con closets amplios y cocina equipada con electrodomésticos. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados. También ofrecemos lavandería, almacenamiento, estacionamiento, un área de juegos y mantenimiento de emergencia las 24 horas. Pague la renta y pida reparaciones en línea. Pregunte por nuestra política de mascotas y programe una visita a 1869 West hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d94-f24c-7738-a05e-877e3cf49ebd.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building with a manicured lawn and walkway.",
        "public_id": "01a13d94-f24c-7738-a05e-877e3cf49ebd",
        "storage_key": "property/6767906449166965/01a13d94-f24c-7738-a05e-877e3cf49ebd.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos que Aceptan Mascotas Pittsburgh | 1869 West",
      "seo_description": "Apartamentos que aceptan mascotas en Pittsburgh, PA. Unidades de 1, 2 y 3 habitaciones con jardines y estacionamiento en 1869 West. Programe una visita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-de-1-habitacion-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos de 1 Habitación en Pittsburgh",
      "h2_subtitle": "Apartamentos de una habitación de 575 pies cuadrados en Westwood, Pittsburgh",
      "page_copy": "1869 West ofrece apartamentos de una habitación (también conocidos como apartamentos de una recámara) en Pittsburgh, PA, a un precio accesible. El plano de 575 pies cuadrados incluye una habitación separada, sala y una cocina equipada con electrodomésticos, además de closets amplios. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados.\n\nEstamos en el vecindario de Westwood, entre Crafton y Green Tree, a poca distancia en carro del centro de Pittsburgh. La comunidad ofrece lavandería, almacenamiento, estacionamiento, un área de juegos y mantenimiento de emergencia las 24 horas. Puede pagar la renta en línea y preguntar por contratos a corto plazo. Se aceptan mascotas. Consulte disponibilidad y programe una visita hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d95-2628-779b-851c-da71389878c3.webp",
      "featured_image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, nightstand, and decorative artwork.",
        "public_id": "01a13d95-2628-779b-851c-da71389878c3",
        "storage_key": "property/6767906449166965/01a13d95-2628-779b-851c-da71389878c3.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos de 1 Habitación en Pittsburgh | 1869 West",
      "seo_description": "Apartamentos de 1 habitación en Pittsburgh, PA. 575 pies cuadrados con closets amplios y cocina equipada en 1869 West. Consulte disponibilidad hoy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-de-2-habitaciones-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos de 2 Habitaciones en Pittsburgh",
      "h2_subtitle": "Apartamentos de dos habitaciones de 625 y 675 pies cuadrados en Westwood, Pittsburgh",
      "page_copy": "1869 West ofrece apartamentos de dos habitaciones (dos recámaras) en Pittsburgh, en dos planos de 625 y 675 pies cuadrados. La segunda habitación sirve para un niño, un compañero de cuarto, visitas o una oficina en casa, y los closets amplios ayudan a mantener todo en orden. Cada unidad tiene cocina equipada con electrodomésticos.\n\nAfuera, los jardines, el área de juegos y el estacionamiento hacen que 1869 West se sienta como un vecindario. También hay lavandería, almacenamiento, administración en el lugar y mantenimiento de emergencia las 24 horas, y puede pagar la renta en línea. Se aceptan mascotas. Estamos en Westwood, entre Crafton y Green Tree. Consulte disponibilidad de nuestros apartamentos de 2 habitaciones y programe una visita hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d95-5c49-748b-bd24-fa666ea5711b.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and TV stand.",
        "public_id": "01a13d95-5c49-748b-bd24-fa666ea5711b",
        "storage_key": "property/6767906449166965/01a13d95-5c49-748b-bd24-fa666ea5711b.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos de 2 Habitaciones Pittsburgh | 1869 West",
      "seo_description": "Apartamentos de 2 habitaciones en Pittsburgh, PA. Planos de 625 y 675 pies cuadrados con closets amplios y lavandería en 1869 West. Programe una visita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-de-3-habitaciones-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos de 3 Habitaciones en Pittsburgh",
      "h2_subtitle": "Apartamentos de tres habitaciones de 725 pies cuadrados para familias en Westwood, Pittsburgh",
      "page_copy": "No es fácil encontrar apartamentos de tres habitaciones (tres recámaras) a buen precio en Pittsburgh. En 1869 West, nuestro plano de 725 pies cuadrados le da a cada quien su propia habitación, con closets amplios y cocina equipada con electrodomésticos. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados.\n\nLos niños pueden jugar en el área de juegos y en los jardines entre los edificios, y la comunidad ofrece lavandería, almacenamiento extra y estacionamiento. Contamos con administración en el lugar y mantenimiento de emergencia las 24 horas, y la renta se paga en línea. Se aceptan mascotas. Estamos en Westwood, cerca de parques, escuelas y del centro de Pittsburgh. Programe una visita a nuestros apartamentos de 3 habitaciones hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d95-90a4-71dc-a46c-f7491840211e.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with two grey accent chairs, a coffee table, and a sofa.",
        "public_id": "01a13d95-90a4-71dc-a46c-f7491840211e",
        "storage_key": "property/6767906449166965/01a13d95-90a4-71dc-a46c-f7491840211e.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos de 3 Habitaciones Pittsburgh | 1869 West",
      "seo_description": "Apartamentos de 3 habitaciones en Pittsburgh, PA. Unidades de 725 pies cuadrados con área de juegos y lavandería en 1869 West. Programe una visita hoy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-economicos-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos Económicos en Pittsburgh, PA",
      "h2_subtitle": "Apartamentos accesibles de 1, 2 y 3 habitaciones en Westwood, cerca del centro de Pittsburgh",
      "page_copy": "En 1869 West encontrará apartamentos económicos en Pittsburgh, PA, sin sacrificar espacio ni comodidad. Nuestra comunidad en Westwood ofrece planos de una, dos y tres habitaciones con closets amplios y cocinas equipadas, en un vecindario tranquilo entre Crafton y Green Tree.\n\nLa comunidad tiene estacionamiento, lavandería, espacio de almacenamiento y un área de juegos para niños. Pague la renta en línea, pida reparaciones desde su teléfono y cuente con mantenimiento de emergencia las 24 horas. Ofrecemos contratos a corto plazo y se aceptan mascotas. Llame o visite la oficina de alquiler para conocer los precios actuales y las promociones disponibles. Programe una visita a 1869 West hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d95-c697-770c-ae48-ec26ae7e3fff.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets and a black refrigerator",
        "public_id": "01a13d95-c697-770c-ae48-ec26ae7e3fff",
        "storage_key": "property/6767906449166965/01a13d95-c697-770c-ae48-ec26ae7e3fff.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos Económicos en Pittsburgh | 1869 West",
      "seo_description": "Apartamentos económicos en Pittsburgh, PA. Unidades de 1, 2 y 3 habitaciones con estacionamiento y lavandería en 1869 West, Westwood. Programe una visita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-cerca-de-beechview-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos Cerca de Beechview en Pittsburgh",
      "h2_subtitle": "Apartamentos de 1, 2 y 3 habitaciones en Westwood, a poca distancia en carro de Beechview",
      "page_copy": "1869 West está a poca distancia en carro de Beechview, el vecindario de Pittsburgh conocido por sus tiendas y restaurantes latinos a lo largo de Broadway Avenue. Desde nuestra comunidad en Westwood, también está cerca de las escuelas de Beechview, como Brashear High School y South Hills 6-8.\n\nElija un apartamento de una habitación (575 pies cuadrados), de dos habitaciones (625 o 675 pies cuadrados) o de tres habitaciones (725 pies cuadrados), con closets amplios y cocina equipada con electrodomésticos. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados. La comunidad ofrece lavandería, almacenamiento, estacionamiento, un área de juegos y mantenimiento de emergencia las 24 horas, y puede pagar la renta en línea. Se aceptan mascotas. Programe una visita a nuestros apartamentos cerca de Beechview hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d95-fd7f-758f-85da-d5ee4fa88708.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding landscape.",
        "public_id": "01a13d95-fd7f-758f-85da-d5ee4fa88708",
        "storage_key": "property/6767906449166965/01a13d95-fd7f-758f-85da-d5ee4fa88708.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos Cerca de Beechview Pittsburgh | 1869 West",
      "seo_description": "Apartamentos cerca de Beechview en Pittsburgh. Unidades de 1, 2 y 3 habitaciones en Westwood con estacionamiento y área de juegos en 1869 West. Visítenos.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-con-lavanderia-y-estacionamiento-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos con Lavandería y Estacionamiento",
      "h2_subtitle": "Lavandería y estacionamiento en la comunidad, en apartamentos de Westwood, Pittsburgh",
      "page_copy": "En 1869 West, las tareas de todos los días son más fáciles. Nuestra comunidad en Westwood, Pittsburgh, tiene lavandería en el lugar, así que no tiene que salir a una lavandería pública, y estacionamiento para que siempre tenga dónde dejar su carro al llegar a casa.\n\nElija un apartamento de una habitación (575 pies cuadrados), de dos habitaciones (625 o 675 pies cuadrados) o de tres habitaciones (725 pies cuadrados), con closets amplios y cocina equipada con electrodomésticos. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados. También ofrecemos espacio de almacenamiento, un área de juegos y mantenimiento de emergencia las 24 horas, y puede pagar la renta y pedir reparaciones en línea. Se aceptan mascotas. Estamos entre Crafton y Green Tree, cerca del centro de Pittsburgh. Programe una visita a 1869 West hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d96-35c3-700a-86ed-f31b275b5f2d.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with manicured lawns and sidewalks under a blue sky with clouds.",
        "public_id": "01a13d96-35c3-700a-86ed-f31b275b5f2d",
        "storage_key": "property/6767906449166965/01a13d96-35c3-700a-86ed-f31b275b5f2d.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos con Lavandería y Estacionamiento | 1869 West",
      "seo_description": "Apartamentos con lavandería y estacionamiento en Pittsburgh, PA. Unidades de 1, 2 y 3 habitaciones en Westwood en 1869 West. Programe una visita hoy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-con-contrato-a-corto-plazo-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos con Contrato a Corto Plazo en Pittsburgh",
      "h2_subtitle": "Contratos de alquiler a corto plazo en apartamentos de 1, 2 y 3 habitaciones en Westwood",
      "page_copy": "¿Necesita un apartamento en Pittsburgh por poco tiempo? 1869 West ofrece contratos a corto plazo, ideales si está empezando un trabajo nuevo, esperando comprar casa o mudándose a la ciudad. Pregunte en la oficina de alquiler por los plazos disponibles.\n\nElija un apartamento de una habitación (575 pies cuadrados), de dos habitaciones (625 o 675 pies cuadrados) o de tres habitaciones (725 pies cuadrados), con closets amplios y cocina equipada con electrodomésticos. Algunas unidades tienen pisos de vinil tipo madera y gabinetes renovados. La comunidad tiene lavandería, almacenamiento, estacionamiento, un área de juegos y mantenimiento de emergencia las 24 horas. Puede pagar la renta y pedir reparaciones en línea. Se aceptan mascotas. Estamos en Westwood, entre Crafton y Green Tree, a poca distancia en carro del centro de Pittsburgh. Programe una visita hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d96-6d99-704f-b376-5fa97c2ebe32.webp",
      "featured_image_media": {
        "alt_text": "Living room and kitchen area in an apartment with a sofa, chairs, coffee table, and a kitchenette.",
        "public_id": "01a13d96-6d99-704f-b376-5fa97c2ebe32",
        "storage_key": "property/6767906449166965/01a13d96-6d99-704f-b376-5fa97c2ebe32.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Contrato a Corto Plazo en Pittsburgh | 1869 West",
      "seo_description": "Apartamentos con contrato a corto plazo en Pittsburgh, PA. Unidades de 1, 2 y 3 habitaciones con estacionamiento en 1869 West. Pregunte hoy por disponibilidad.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166965",
      "source": "custom",
      "page_item_url": "apartamentos-con-area-de-juegos-para-ninos-pittsburgh-1869-west",
      "search_query": "",
      "category": "",
      "h1_title": "Apartamentos con Área de Juegos para Niños en Pittsburgh",
      "h2_subtitle": "Apartamentos familiares de 2 y 3 habitaciones con área de juegos en Westwood, Pittsburgh",
      "page_copy": "1869 West tiene un área de juegos para niños en la misma comunidad, además de jardines amplios entre los edificios. Estamos en Westwood, Pittsburgh, a poca distancia de Pittsburgh Westwood K-5 y cerca de parques como Oakwood Park y Green Tree Park. Consulte con Pittsburgh Public Schools qué escuela corresponde a su dirección.\n\nNuestros apartamentos de dos habitaciones (625 o 675 pies cuadrados) y de tres habitaciones (725 pies cuadrados) tienen closets amplios y cocina equipada, y también hay apartamentos de una habitación. La comunidad ofrece lavandería, almacenamiento, estacionamiento y mantenimiento de emergencia las 24 horas. Se aceptan mascotas. Programe una visita a 1869 West hoy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166965/01a13d96-a331-73a8-9c4b-7b72c0f2b214.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building entrance with a sidewalk and grassy lawn.",
        "public_id": "01a13d96-a331-73a8-9c4b-7b72c0f2b214",
        "storage_key": "property/6767906449166965/01a13d96-a331-73a8-9c4b-7b72c0f2b214.webp",
        "width": 1280,
        "height": 851
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartamentos con Área de Juegos Pittsburgh | 1869 West",
      "seo_description": "Apartamentos con área de juegos para niños en Pittsburgh, PA. Unidades de 2 y 3 habitaciones con jardines y lavandería en 1869 West. Programe una visita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5802"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10893623061"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4972930"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NF5558L6"
    },
    {
      "ID": "custom_realpage_id_2",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://live1869west.fatwin.com/api/websites/resources/1?x=SDhZOG1xdC8wcGNGRHUzZFl5YXZ3VHo3cWNzdklFUk1zN0JIVmhOT3Y5bStuVm1nS2ZEdnk5aVBLclQvc1htSnJtb1hRakZVMEhXUGdsdGhTN2o1VWc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yjp2d435vxl"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_resident_portal_url_2",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95496f1e-43e6-11ef-8604-03b4fb52a8d2"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95496f1e-43e6-11ef-8604-03b4fb52a8d2/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95496f1e-43e6-11ef-8604-03b4fb52a8d2/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImJZeTlFSTlMZkNPa00wWkY0OGloYXc9PSIsInZhbHVlIjoiNUxPaHg4Sm9qc0pySnhDYWJpQWZ0Zz09IiwibWFjIjoiMzQwNzA2NjczNTkyMGI4NGM0MDBmYmEwOTI2N2JkY2E2YzE0MTEwYjJiYjU1MzVmODlhMDNmMTEwOGUwNmFkZSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5802",
  "custom_repli_id": "10893623061",
  "custom_realpage_id": "4972930",
  "custom_google_gtm_id": "GTM-NF5558L6",
  "custom_perq_script_url": "https://live1869west.fatwin.com/api/websites/resources/1?x=SDhZOG1xdC8wcGNGRHUzZFl5YXZ3VHo3cWNzdklFUk1zN0JIVmhOT3Y5bStuVm1nS2ZEdnk5aVBLclQvc1htSnJtb1hRakZVMEhXUGdsdGhTN2o1VWc9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/yjp2d435vxl",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95496f1e-43e6-11ef-8604-03b4fb52a8d2",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95496f1e-43e6-11ef-8604-03b4fb52a8d2/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95496f1e-43e6-11ef-8604-03b4fb52a8d2/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImJZeTlFSTlMZkNPa00wWkY0OGloYXc9PSIsInZhbHVlIjoiNUxPaHg4Sm9qc0pySnhDYWJpQWZ0Zz09IiwibWFjIjoiMzQwNzA2NjczNTkyMGI4NGM0MDBmYmEwOTI2N2JkY2E2YzE0MTEwYjJiYjU1MzVmODlhMDNmMTEwOGUwNmFkZSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "ad30eca5-2b04-418a-9e09-eb8ddfd6da8b",
  "custom_audioeye_site_hash": "9c54c0e0c94ecf9edfc15a28c023a957"
};

export const generatedAt = '2026-10-22T20:05:06.283Z';
